import React, { PureComponent } from "react";
import {
  Card,
  CardBody,
  Col,
  Button,
  ButtonToolbar,
  Container,
  Row,
  Table,
  Modal,
} from "reactstrap";
import _ from "lodash";
import { Field, reduxForm } from "redux-form";
import moment from "moment";
import "./styles.css";
import EyeIcon from "mdi-react/EyeIcon";
import EmailIcon from "mdi-react/EmailIcon";
import AccountSearchIcon from "mdi-react/AccountSearchIcon";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import renderFileInputField from "../../../../shared/components/form/FileInput";
import renderSelectField from "../../../../shared/components/form/Select";
import renderMultiSelectField from "../../../../shared/components/form/MultiSelect";
import Util from '../../../Common/util';
import API from '../../../Common/api';
import {
  MDBDataTable,
  MDBBtn,
  MDBTable,
  MDBTableBody,
  MDBTableHead,
} from "mdbreact";
import axios from "axios";
import Select from "react-select";
import DatePicker from "react-datepicker";
import MUIDataTable from "mui-datatables";
import "antd/dist/antd.css";
import { TimePicker } from "antd";
import "react-datepicker/dist/react-datepicker.css";
import styled, { css } from "styled-components";
import {
  createMuiTheme,
  ThemeProvider,
  withStyles,
} from "@material-ui/core/styles";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload, faSyncAlt } from "@fortawesome/free-solid-svg-icons";
import { faPlus, faMinus, faPen } from "@fortawesome/free-solid-svg-icons";
import LoadingOverlay from 'react-loading-overlay';
import DarkBackground from '../../../Common/backgroundLoader';
import {addAnalytics, paginationAnalytics} from '../../../Common/analytics';
import { TurnedIn } from "@material-ui/icons";
import { toString } from "file-loader";


var url = window.location.hostname;
var port = window.location.port;

const fileType =
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
const fileExtension = ".xlsx";

class HorizontalForm extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
  };

  constructor() {
    super();
    this.toggle = this.toggle.bind(this);
    this.Errortoggle = this.Errortoggle.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.EditToggle = this.EditToggle.bind(this);
    this.togglePressCancel = this.togglePressCancel.bind(this);
    this.showTypeahead = this.showTypeahead.bind(this);
    this.showTypeaheadChange = this.showTypeaheadChange.bind(this);
    this.closeContainer = this.closeContainer.bind(this);
    this.setBinId = this.setBinId.bind(this);
    this.onQuantityChange1 = this.onQuantityChange1.bind(this);
    this.changeICLDQty = this.changeICLDQty.bind(this);
    this.changeLooseQty = this.changeLooseQty.bind(this);
    this.changeTesterQty = this.changeTesterQty.bind(this);
    this.processData = this.processData.bind(this);
    this.CancelErrorToggle = this.CancelErrorToggle.bind(this);
    this.ConfirmPutAway = this.ConfirmPutAway.bind(this);
    this.Successtoggle = this.Successtoggle.bind(this);
    this.CancelSuccessToggle = this.CancelSuccessToggle.bind(this);
    this.Confirmtoggle = this.Confirmtoggle.bind(this);
    this.CancelConfirmToggle = this.CancelConfirmToggle.bind(this);
    this.CancelErrorMessageToggle = this.CancelErrorMessageToggle.bind(this);
    this.handleChangeDate = this.handleChangeDate.bind(this);
    this.ErrorMessagetoggle = this.ErrorMessagetoggle.bind(this);
    
    this.accessCookie = this.accessCookie.bind(this);
    this.beforeConfirm = this.beforeConfirm.bind(this);
    this.CancelBeforeModal = this.CancelBeforeModal.bind(this);
    this.handleChangeTime = this.handleChangeTime.bind(this);
    /*this.showTypeahead = this.showTypeahead.bind(this);*/
    this.state = {
	  loading_overlay: false,	
      reasonDropdown: [],
      pickingHisCancel: false,
      cancelDisableBtn: true,
      pickHisIdToCancel: [],
      showPassword: false,
      loading: false,
      startDate: new Date(),
      disabledPutaway: false,
      schemas: [],
      showFetchGRNData: false,
      showFetchGRNDataTester: false,
      updateDisabled: false,
      showConfirmLoader: false,
      loadingupdatebtn: false,
      disabledBtnConfirm: false,
      label_val: "",
      pickingHistoryId: "0",
      rows: [],
      grnNumber: "",
      batch_id: "",
      selectedOptions: "",
      errorMessage: "",
      changeStatus: "",
      loadingbtn: false,
      alertMessage: "",
      messageModal: false,
      ErrorMessagemodal: false,
      postsGRN: [],
      postsProduct: [],
      tableRowsGRN: [],
      tableRowsGRNTester: [],
      ErrorRowData: [],
      options: [],
      newArrayData: [],
      selectedUser: {},
      showDateError: {},
      modal: false,
      Confirmmodal: false,
      EditModal: false,
      typeaheadText: "",
      pkd_val: "",
      lbskuid_val: "",
      mrp_val: "",
      quantity: "",
      defaultquantity: "",
      putawayHistoryId: "",
      showTypeahead: false,
      zwz_search_pannel: false,
      showUpdateLoader: false,
      data: [],
      binId: "",
      hover_nod_data: [],
      showContainer: [],
      setBinIdLoop: {},
      splitData: [],
      Errormodal: false,
      Successmodal: false,
      ErrorMessage: "",
      SuccessMessage: "",
      showICLDError: false,
      showLooseError: false,
      showTesterError: false,
      disabledBtn: false,
      selected: {},
      selected_all: false,
      short_picking_selected: {},
      short_picking_selected_all: false,
      sp_proceed_btn_disabled: true,
      downloadData: [],
      table_row: { 0: [] },
      table_row_flag: false,
      putawayBtnflag: false,
      editBtnFlag: true,
      pendingBtnflag: false,
      showICLDReasonCode: false,
      showLOOSEReasonCode: false,
      showTESTERReasonCode: false,
      pickingConfrimId: [],
      shortPickingRows: [],
      shortPickingModal: false,
      validateReasonCode: false,
      stock_available_not_zero: false,

      showMandatoryCrateId: {},
      showMandatoryCrateLoose: {},
      showMandatoryCrateIcld: {},
      showPickCrateLoose: false,
      showPickCrateIcld: false,
      pickHistoryCrateArr: {},
      isEmptyCrateArr: false,
      isDisabledLOOSE: true,
      isDisabledICLD: true,
      reason_code: {},
      disabledconfirmBtn : false,
      picking_app : false,
      emp_role :"",
      columnsTester: [
        {
          label: (
            <input
              type="checkbox"
              name="select_all_checkbox"
              selected={false}
              checked = {true}
              disabled = {true}
              onChange={this.handleallCheckBoxClick}
            />
          ),
          name: "checkbox",
        },
        {
          label: "S No.",
          name: "serial",
        },
        {
          label: "BIN Id",
          name: "binId",
        },
        {
          label: "BasePack Code",
          name: "basepackCode",
        },
        {
          label: "Zone Name",
          name: "zone_name",
        },
        /*{
          label: "Zone Id",
          name: "zone_id",
        },*/
        {
          label: "LB SKU ID",
          name: "lbskuid",
        },
        {
          label: "MRP",
          name: "mrp",
        },
        {
          label: "CBU Code",
          name: "cbuCode",
        },
        {
          label: "Party Name",
          name: "partyName",
        },
        {
          label: "To Pick Icld Quantity (Box)",
          name: "toPickIcldQty",
        },
        {
          label: "To Pick Loose Quantity (pcs)",
          name: "toPickLooseQty",
        },
        {
          label: " To Pick Tester Quantity (pcs)",
          name: "toPickTesterQty",
        },
        {
          label: "Picked Icld Quantity (Box)",
          name: "PickIcldQty",
        },
        {
          label: "Picked Loose Quantity (pcs)",
          name: "PickLooseQty",
        },
        {
          label: "Picked Tester Quantity (pcs)",
          name: "PickTesterQty",
        },
        {
          label: "PKD",
          name: "pkd",
        },
        {
          label: "Action",
          name: "action",
        },
      ],
      columns: [
        {
          label: (
            <input
              type="checkbox"
              name="select_all_checkbox"
              checked = {true}
              disabled = {true}
              selected={false}
              onChange={this.handleallCheckBoxClick}
            />
          ),
          name: "checkbox",
        },
        {
          label: "S No.",
          name: "serial",
        },
        {
          label: "BIN Id",
          name: "binId",
        },
        {
          label: "Zone Name",
          name: "zone_name",
        },
        /*{
          label: "Zone Id",
          name: "zone_id",
        },*/
        {
          label: "LB SKU ID",
          name: "lbskuid",
        },
        {
          label: "MRP",
          name: "mrp",
        },
        {
          label: "CBU Code",
          name: "cbuCode",
        },
        {
          label: "To Pick Icld Quantity (Box)",
          name: "toPickIcldQty",
        },
        {
          label: "To Pick Loose Quantity (pcs)",
          name: "toPickLooseQty",
        },
        {
          label: " To Pick Tester Quantity (pcs)",
          name: "toPickTesterQty",
        },
        {
          label: "Picked Icld Quantity (Box)",
          name: "PickIcldQty",
        },
        {
          label: "Picked Loose Quantity (pcs)",
          name: "PickLooseQty",
        },
        {
          label: "Picked Tester Quantity (pcs)",
          name: "PickTesterQty",
        },
        {
          label: "PKD",
          name: "pkd",
        },
        {
          label: "Action",
          name: "action",
        },
      ],
      column_type: "",
    };
  }

  handleChangeDate(key, date) {
    const { newArrayData } = this.state;
    this.setState(
      {
        newArrayData: newArrayData.map((item) => ({
          ...item,
          date:
            item.userName === key
              ? moment(new Date(date).getTime()).format("MM-DD-YYYY")
              : item.date || null,
        })),
      },
      () => {
      }
    );
  }

  exportToCSV = (filename) => {
    var FileName = filename;
    var csvData = this.state.downloadData;
    const arr = [];

    for (var i = 0; i < csvData.length; i++) {
      //FileName = csvData[i].fileName;
      var orderData = {};

      orderData["Sr No."] = csvData[i].sr_no;
      orderData["Order Number"] = csvData[i].order_number;
      orderData["Packing Station ID"] = csvData[i].packing_station_id;
      orderData["LBSKUID"] = csvData[i].lb_sku_id;
      orderData["PKM"] = csvData[i].pkm;
      orderData["Crate ID"] = csvData[i].crate_name;
      orderData["Picked Product"] = csvData[i].picked_product;
      orderData["Product Type"] = csvData[i].product_type;
      orderData["Picked PKM"] = csvData[i].picked_pkm;
      orderData["Picked OCLD Quantity"] = csvData[i].picked_ocld_qty;
      orderData["Picked ICLD Quantity"] = csvData[i].picked_icld_qty;
      orderData["Picked Loose Quantity"] = csvData[i].picked_loose_qty;
      orderData["Total Quantity"] = csvData[i].picked_total_qty;
      orderData["Action"] = csvData[i].action;

      arr.push(orderData);
    }

    if (arr.length == 0) {
      var orderData = {};
      orderData["Sr No."] = "";
      orderData["Order Number"] = "";
      orderData["Packing Station ID"] = "";
      orderData["LBSKUID"] = "";
      orderData["PKM"] = "";
      orderData["Crate ID"] = "";
      orderData["Picked Product"] = "";
      orderData["Product Type"] = "";
      orderData["Picked PKM"] = "";
      orderData["Picked OCLD Quantity"] = "";
      orderData["Picked ICLD Quantity"] = "";
      orderData["Picked Loose Quantity"] = "";
      orderData["Total Quantity"] = "";
      orderData["Action"] = "";

      arr.push(orderData);
    }

    const ws = XLSX.utils.json_to_sheet(arr);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, FileName + fileExtension);
  };

  processUpdateData = () => {
    this.setState({
      showUpdateLoader: true,
      showPickCrateIcld: false,
      showPickCrateLoose: false,
      updateDisabled: true
    });

    var total_Quantity =
      this.state.checkicldQty * this.state.upcQty + this.state.checklooseQty;

    if (this.state.checkicldQty < this.state.icldQty1) {
      this.setState({
        showICLDError: true,
        showUpdateLoader: false,
        updateDisabled: false
      });
      return false;
    } else {
      this.setState({
        showICLDError: false,
      });
    }

    /* if (this.state.checklooseQty < this.state.looseQty) {
      this.setState({
        showLooseError: true
      })
      return false;
    }else{

      this.setState({
        showLooseError: false
      })

    }*/

    var sum_data =
      parseInt(this.state.icldQty1) * this.state.upcQty +
      parseInt(this.state.looseQty1);

    if (this.state.PickType != undefined && this.state.PickType != "") {
      if (
        (this.state.PickType.toUpperCase() == "LOOSE" ||
          this.state.PickType.toUpperCase() == "OUTER" ||
          this.state.PickType.toUpperCase() == "CARTON") &&
        total_Quantity < sum_data
      ) {
        this.setState({
          showLooseError: true,
          showUpdateLoader: false,
        });
        return false;
      } else {
        this.setState({
          showLooseError: false,
        });
      }
    }

    if (this.state.checktesterQty < this.state.testerQty1) {
      this.setState({
        showTesterError: true,
        showUpdateLoader: false,
      });
      return false;
    } else {
      this.setState({
        showTesterError: false,
      });
    }

    /* 
    Snippet to handle Crate Process. START
  */
    var crate_ids = [];
    var crateelements = document.getElementsByClassName("crate_input_id");
    var looseelements = document.getElementsByClassName("crate_input_id_loose");
    var icldelements = document.getElementsByClassName("crate_input_id_icld");

    let loose_element_sum = 0;
    let icld_element_sum = 0;
    let mandatoryCrateIDs = { ...this.state.showMandatoryCrateId };
    let mandatorycrateLooseQty = { ...this.state.showMandatoryCrateLoose };
    let mandatorycrateIcldQty = { ...this.state.showMandatoryCrateIcld };

    for (var i = 0, len = crateelements.length; i < len; i++) {
      if (this.state.PickType == "OUTER") {
        if (
          crateelements[i].value == "" ||
          crateelements[i].value == undefined
        ) {
          mandatoryCrateIDs[i + 1] = true;
          this.setState({
            showMandatoryCrateId: mandatoryCrateIDs,
            showUpdateLoader: false,
          });
          return false;
        } else {
          mandatoryCrateIDs[i + 1] = false;
          this.setState({ showMandatoryCrateId: mandatoryCrateIDs });
        }

        if (
          (looseelements[i].value == "" ||
            looseelements[i].value == undefined) &&
          this.state.isDisabledLOOSE == false
        ) {
          mandatorycrateLooseQty[i + 1] = true;
          this.setState({
            showMandatoryCrateLoose: mandatorycrateLooseQty,
            showUpdateLoader: false,
          });
          return false;
        } else {
          mandatorycrateLooseQty[i + 1] = false;
          this.setState({ showMandatoryCrateLoose: mandatorycrateLooseQty });
        }

        if (
          (icldelements[i].value == "" || icldelements[i].value == undefined) &&
          this.state.isDisabledICLD == false
        ) {
          mandatorycrateIcldQty[i + 1] = true;
          this.setState({
            showMandatoryCrateIcld: mandatorycrateIcldQty,
            showUpdateLoader: false,
          });
          return false;
        } else {
          mandatorycrateIcldQty[i + 1] = false;
          this.setState({ showMandatoryCrateIcld: mandatorycrateIcldQty });
        }

        if (icldelements[i].value == "" || icldelements[i].value == undefined) {
          icldelements[i].value = 0;
        }

        if (
          looseelements[i].value == "" ||
          looseelements[i].value == undefined
        ) {
          looseelements[i].value = 0;
        }

        crate_ids.push({
          crate_id: crateelements[i].value,
          loose_qty: looseelements[i].value,
          icld_qty: icldelements[i].value,
        });

        loose_element_sum =
          loose_element_sum +
          (parseInt(icldelements[i].value) * parseInt(this.state.upcQty) +
            parseInt(looseelements[i].value));
        icld_element_sum = icld_element_sum + parseInt(icldelements[i].value);
      } else {
        if (
          looseelements[i].value == "" ||
          looseelements[i].value == undefined
        ) {
          looseelements[i].value = 0;
        }

        if (icldelements[i].value == "" || icldelements[i].value == undefined) {
          icldelements[i].value = 0;
        }
        crate_ids.push({
          crate_id: crateelements[i].value,
          loose_qty: looseelements[i].value,
          icld_qty: icldelements[i].value,
        });

        loose_element_sum =
          loose_element_sum +
          (parseInt(icldelements[i].value) * parseInt(this.state.upcQty) +
            parseInt(looseelements[i].value));
        icld_element_sum = icld_element_sum + parseInt(icldelements[i].value);
      }
    }
    /* 
    Snippet to handle Crate Process. END
  */

    if (this.state.PickType == "OUTER") {
      if (sum_data != loose_element_sum) {
        this.setState({
          showPickCrateLoose: true,
          showUpdateLoader: false,
        });
        return false;
      } else {
        this.setState({
          showPickCrateLoose: false,
        });
      }
    } else {
      if (crate_ids.length > 0) {
        if (crate_ids[0].crate_id != "" && crate_ids[0].crate_id != undefined) {
          /*var qty_not_zero = this.state.checklooseQty;
          if(this.state.PickType == "TESTER"){
            sum_data = this.state.testerQty1;
            qty_not_zero = this.state.checktesterQty;
          }*/
          if (
            sum_data != loose_element_sum //&&
            //parseInt(qty_not_zero) != 0
          ) {
            this.setState({
              showPickCrateLoose: true,
              showUpdateLoader: false,
            });
            return false;
          } else {
            this.setState({
              showPickCrateLoose: false,
            });
          }
        } else {
          this.setState({
            showPickCrateLoose: false,
          });
        }
      } else {
        this.setState({
          showPickCrateLoose: false,
        });
      }
    }

    /*if (this.state.PickType == "ICLD") {
      if(crate_ids.length > 0){
          if(crate_ids[0].crate_id != "" && crate_ids[0].crate_id != undefined){
            if (
              this.state.icldQty1 != icld_element_sum &&
              parseInt(this.state.checkicldQty) != 0
            ) {
              this.setState({
                showPickCrateIcld: true,
                showUpdateLoader: false,
              });
              return false;
            }else{
              this.setState({
                showPickCrateIcld: false,
              });  
            }
          }else{
            this.setState({
              showPickCrateIcld: false,
            });
          }
        }else{
          this.setState({
              showPickCrateIcld: false,
          });
        }
    }*/

    if (this.state.showTESTERReasonCode == true) {
      if (
        this.state.reason_code[this.state.pickingHistoryId] == "" ||
        this.state.reason_code[this.state.pickingHistoryId] == "0" ||
        this.state.reason_code[this.state.pickingHistoryId] == undefined
      ) {
        this.setState({
          validateReasonCode: true,
          showUpdateLoader: false,
        });
        return false;
      } else {
        this.setState({
          validateReasonCode: false,
        });
      }
    } else {
      this.setState({
        validateReasonCode: false,
      });
    }

    let pickHistoryCrateArr = { ...this.state.pickHistoryCrateArr };
    pickHistoryCrateArr[this.state.pickingHistoryId] = crate_ids;
    this.setState({
      pickHistoryCrateArr: pickHistoryCrateArr,
    });

    const payload = {
      pickedIcldQty: this.state.icldQty1,
      pickedLooseQty: this.state.looseQty1,
      pickedTesterQty: this.state.testerQty1,
      pickingHistoryId: this.state.pickingHistoryId,
      location: this.state.selectedLocation,
      reason_code: this.state.reason_code[this.state.pickingHistoryId],
  };
   addAnalytics('Picking Confirmation', 'Picking Update Data', payload);

API.post('/picking/editPicking/v1/', { param: payload })
      .then((response) => {
        if (response.data.success === true) {
          this.setState({
            EditModal: false,
          });
        }

        this.setState({
          showUpdateLoader: false,
          showICLDReasonCode: false,
          showLOOSEReasonCode: false,
          showTESTERReasonCode: false,
          updateDisabled: false
        });

        this.fetchGRNData();
      })
      .catch(function (error) {});
  };

  putawayClick = () => {
    this.setState({
      putawayBtnflag: false,
      putawayBtnflag: true
    });

    const payload = {
      pick_confirm_ids: this.state.pickingConfrimId,
      location: this.state.selectedLocation,
  };

API.post('/picking/picking_putaway/v1/', { param: payload })
      .then((response) => response.data)
      .then((data) => {
        this.setState({
          putawayBtnflag: false
        })
        window.location.href = "/putaway/printPutaway";
      });
  };
  shortPickingModalToggle = () => {
    this.setState({ shortPickingModal: !this.state.shortPickingModal });
    this.setState(
      {
        shortPickingRows: [],
      },
      () => {
        this.pickingpendingList();
      }
    );
  };

  completeShortPicking = () => {
    var pick_hist_id = [];

    /*for(var i = 0 ; i < this.state.postsGRN.length ; i++){
      pick_hist_id.push(this.state.postsGRN[i].pickingHistoryId)
    }*/

    for (var picking_hist_id_index in this.state.short_picking_selected) {
      if (this.state.short_picking_selected[picking_hist_id_index] == true) {
        var picking_hist_id = picking_hist_id_index.split("_")[1];
        if (pick_hist_id.indexOf(picking_hist_id) <= -1) {
          pick_hist_id.push(picking_hist_id);
        }
      }
    }

    const payload = {
      pick_request_ids: pick_hist_id,
      location: this.state.selectedLocation,
  };

API.post('/picking/closePicking/v1/', { param: payload })
      .then((response) => response.data)
      .then((data) => {
        window.location.href = "/picking/pickingConfirmation";
      });
  };

  pickingpendingClick = () => {
    var pick_hist_id = [];

    for (var picking_hist_id_index in this.state.short_picking_selected) {
      if (this.state.short_picking_selected[picking_hist_id_index] == true) {
        var picking_hist_id = picking_hist_id_index.split("_")[1];
        if (pick_hist_id.indexOf(picking_hist_id) <= -1) {
          pick_hist_id.push(picking_hist_id);
        }
      }
    }

    const payload = {
      pick_request_ids: pick_hist_id,
      location: this.state.selectedLocation,
  };

API.post('/picking/picking_attempt/v1/', { param: payload })
      .then((response) => response.data)
      .then((data) => {
        window.location.href = "/picking/printPickingSheet";
      });
  };

  pickingpendingList = () => {
    var fileNameValue = localStorage.getItem("fileName");

    const payload = {
      file_name: fileNameValue,
      location: this.state.selectedLocation,
  };

API.post('/picking/pendingPickingRequest/v1/', { param: payload })
      .then((response) => response.data)
      .then((data) => {
        var index = 0;
        var shortPickingpickReqID = [];
        var shortPickingRows = [];
        var stock_available_not_zero = [];

        for (let i = 0; i < data.length; i++) {
          index += 1;

          var checkbox_name = index + "_" + data[i]["picking_request_id"];
          var checkbox_html = (
            <input
              type="checkbox"
              name={checkbox_name}
              className="checkbox_div"
              selected={this.state.short_picking_selected[checkbox_name]}
              onChange={this.handleShortPickingCheckBoxClick}
            />
          );

          let table_row = {
            checkbox: checkbox_html,
            lbSkuId: data[i]["lb_sku_id"],
            productName: data[i]["product_name"],
            pkd: data[i]["pkd"],
            cbuCode: data[i]["cbu_code"],
            basePackCode: data[i]["base_pack_code"],
            pending: data[i]["picking_pending"],
            stock: data[i]["stock_available"],
          };
          shortPickingRows.push(table_row);

          if (
            shortPickingpickReqID.indexOf(data[i]["picking_request_id"]) <= -1
          ) {
            shortPickingpickReqID.push(data[i]["picking_request_id"]);
          }

          if (parseInt(data[i]["stock_available"]) != 0) {
            stock_available_not_zero.push(data[i]["picking_pending"]);
          }
        }

        if (stock_available_not_zero.length > 0) {
          this.setState({
            stock_available_not_zero: false,
          });
        } else {
          this.setState({
            stock_available_not_zero: true,
          });
        }

        this.setState({
          shortPickingRows: shortPickingRows,
          sp_proceed_btn_disabled: true,
        });
      });
  };

  syncClick = () => {
    var filename_sync = [];

    this.state.schemas.map((schema) => filename_sync.push(schema.fileName));

    var fileNameValue = localStorage.getItem("fileName");

    const payload = {
      file_name: [fileNameValue],
      location: this.state.selectedLocation,
  };

API.post('/picking/tp_sync/v1/', { param: payload })
      .then((response) => response.data)
      .then((data) => {
        window.location.reload();
      });
  };

  handleChangeTime(key, time) {
    const timeval = moment(new Date(time).getTime()).format("HH:mm");
    const { newArrayData } = this.state;
    this.setState(
      {
        newArrayData: newArrayData.map((item) => ({
          ...item,
          time:
            item.userName === key
              ? moment(new Date(time).getTime()).format("HH:mm")
              : item.time || null,
        })),
      },
      () => {
      }
    );
  }

  ErrorMessagetoggle() {
    this.setState({
      ErrorMessagemodal: true,
    });
  }

  CancelErrorMessageToggle() {
    this.setState({
      ErrorMessagemodal: false,
    });
  }

  changeICLDQty(evt) {
    this.setState(
      {
        icldQty1: evt.target.value,
      },
      () => {
        if (
          this.state.checkicldQty > this.state.icldQty1 &&
          this.state.checkicldQty != 0
        ) {
          this.setState({
            showTESTERReasonCode: true,
          });
        } else {
          this.setState({
            showTESTERReasonCode: false,
          });
        }
      }
    );
  }

  handlereasoncode = (evt) => {
    let reason_code = { ...this.state.reason_code };
    reason_code[this.state.pickingHistoryId] = evt.target.value;
    this.setState(
      {
        reason_code: reason_code,
      },
      () => {
        if (
          (this.state.reason_code == "" ||
            this.state.reason_code == "0" ||
            this.state.reason_code == undefined) &&
          this.state.validateReasonCode != false
        ) {
          this.setState({
            validateReasonCode: true,
          });
          return false;
        } else {
          this.setState({
            validateReasonCode: false,
          });
        }
      }
    );
  };

  changeLooseQty(evt) {
    this.setState(
      {
        looseQty1: evt.target.value,
      },
      () => {
        var total_Quantity =
          this.state.checkicldQty * this.state.upcQty +
          this.state.checklooseQty;

        var sum_data =
          parseInt(this.state.icldQty1) * this.state.upcQty +
          parseInt(this.state.looseQty1);

        if (total_Quantity > sum_data && total_Quantity != 0) {
          this.setState({
            showTESTERReasonCode: true,
          });
        } else {
          this.setState({
            showTESTERReasonCode: false,
          });
        }
      }
    );
  }

  changeTesterQty(evt) {
    if (this.state.PickType == "LOOSE") {
      this.setState(
        {
          looseQty1: evt.target.value,
        },
        () => {
          var total_Quantity =
            this.state.checkicldQty * this.state.upcQty +
            this.state.checklooseQty;

          var sum_data =
            parseInt(this.state.icldQty1) * this.state.upcQty +
            parseInt(this.state.looseQty1);

          if (total_Quantity > sum_data && total_Quantity != 0) {
            this.setState({
              showTESTERReasonCode: true,
            });
          } else {
            this.setState({
              showTESTERReasonCode: false,
            });
          }
        }
      );
    } else {
      this.setState(
        {
          testerQty1: evt.target.value,
        },
        () => {
          if (
            this.state.checktesterQty > this.state.testerQty1 &&
            this.state.checktesterQty != 0
          ) {
            this.setState({
              showTESTERReasonCode: true,
            });
          } else {
            this.setState({
              showTESTERReasonCode: false,
            });
          }
        }
      );
    }
  }

  EditToggle() {
    this.setState({
      EditModal: true,
    });
  }

  setBinId(item) {
    this.setState({
      typeaheadText: item,
    });
  }

  CancelConfirmToggle() {
    this.setState({
      Confirmmodal: false,
    });
    window.location.reload();
  }

  onQuantityChange1(index, value) {
    const { rows } = this.state;
    this.setState({
      rows: rows.map((item, i) =>
        i === index ? { ...item, qty: value } : item
      ),
    });
  }

  ConfirmPutAway() {
    var currentdate = new Date(); 
var datetime =  currentdate.getDate() + "-"
                + (currentdate.getMonth()+1)  + "-" 
                + currentdate.getFullYear() + " "  
                + currentdate.getHours() + ":"  
                + currentdate.getMinutes() + ":" 
                + currentdate.getSeconds();
      //return false;
    this.setState(
      {
        showConfirmLoader: true,
        disabledBtnConfirm: true,
        loadingbtn: true,
        disabledBtn: true,
        isEmptyCrateArr: false,
      },
      () => {

        var arr = [];
        for (var i = 0; i < this.state.newArrayData.length; i++) {
          if (this.state.newArrayData[i] != undefined) {
            if (this.state.newArrayData[i].editFlag == 0) {
              var orderData = {};
              orderData["pickingHistoryId"] = this.state.newArrayData[
                i
              ].pickingHistoryId;
              orderData["location"] = this.state.selectedLocation;
             /* orderData["date"] =
                this.state.newArrayData[i].date +
                " " +
                this.state.newArrayData[i].time;*/
                orderData["date"] = datetime;

              if (
                Object.keys(this.state.pickHistoryCrateArr).indexOf(
                  orderData["pickingHistoryId"].toString()
                ) > -1
              ) {
                orderData["crates"] = [];
                for (
                  let i = 0;
                  i <
                  this.state.pickHistoryCrateArr[orderData["pickingHistoryId"]]
                    .length;
                  i++
                ) {
                  orderData["crates"].push(
                    this.state.pickHistoryCrateArr[
                      orderData["pickingHistoryId"]
                    ][i]
                  );
                }
              } else {
                orderData["crates"] = [];
              }

              if (this.state.PickType == "OUTER") {
                if (orderData["crates"].length == 0) {
                  this.setState({
                    isEmptyCrateArr: true,
                    showConfirmLoader: false,
                    loadingbtn: false,
                    disabledBtn: false,
                  });
                  return false;
                } else {
                  this.setState({
                    isEmptyCrateArr: false,
                  });
                }
              }

              

              arr.push(orderData);
            }
          }
        }

        this.setState({
          disabledBtnConfirm: true,
        });

        for (let i = 0; i < arr.length; i++) {
          if (arr[i]["crates"] != undefined) {
            if (arr[i]["crates"].length > 0) {
              for (let j = 0; j < arr[i]["crates"].length; j++) {
                if (
                  arr[i]["crates"][j]["crate_id"] == "" ||
                  arr[i]["crates"][j]["crate_id"] == undefined
                ) {
                  arr[i]["crates"].splice(0, 1);
                }
              }
            }
          }
        }

         const payload = {
              location: this.state.selectedLocation,
              arr_data: arr,
              batch_id: this.state.batch_id
          };
           addAnalytics('Picking Confirmation', 'Picking Confirm Data', payload);

        API.post('/picking/confirmPicking/v1/', { param: payload })

      
          .then((response) => {
            /*this.setState({
                  Successmodal: true,
                })*/

            if (response.data[0].success === false) {
              this.setState({
                errorMessage: response.data[0].reason,
                ErrorMessagemodal: true,
                loadingbtn: false,
                modalbeforeConfirm: false,
              });
            } else {
              this.Confirmtoggle();
              this.setState({
                loadingbtn: false,
                modalbeforeConfirm: false,
              });
            }

            this.setState({
              showConfirmLoader: false,
              disabledBtnConfirm: false
            });

            /*window.location.reload();*/
            /* if (response.data[0].success= true) {
                this.setState({
                  Successmodal: true,
                })

                window.location.reload();
              }*/
          })
          .catch(function (error) {});
        /*})*/
      }
    );
  }

  CancelErrorToggle() {
    this.setState({
      Errormodal: false,
    });

    this.handleRemoveRow();
  }

  CancelSuccessToggle() {
    this.setState({
      Successmodal: false,
    });
  }

  CancelSuccessToggle() {
    this.setState({
      Successmodal: false,
    });
  }

  onBinChange1(index, value) {
    /*showTypeahead = (e) => {*/

    /*const data_val = ["B-W-R-2" , "C-D-T-3" , "C-D-T-8" , "C-D-T-8"];*/

    /*console.log(e.target.value);*/

    let { showContainer, rows } = this.state;
    showContainer[index] = true;
    this.setState(
      {
        showContainer,
        rows: rows.map((item, i) =>
          i === index ? { ...item, binId: value } : item
        ),
        /*data: data_val*/
      },
      () => {

        const payload = {
              location: this.state.selectedLocation,
              binAddress: value,
              putawayHistoryId: this.state.putawayHistoryId,
          };

        API.post('/picking/getBins/v1/', { param: payload })
          .then((response) => {
            this.setState({
              data: response.data,
            });
          })
          .catch(function (error) {});
      }
    );

    /*console.log(value);*/
  }

  setBinIdLoop(index, value) {
    const { rows, showContainer } = this.state;
    this.setState({
      rows: rows.map((item, i) =>
        i === index ? { ...item, binId: value } : item
      ),
      showContainer: showContainer.map((item, i) => false),
    });
  }

  hideTypeahead = (e) => {
    if (this.state.showTypeahead) {
      if (!this.typeahead.contains(e.target)) {
        this.setState({ showTypeahead: false });
      }
    }
  };

  handleAddRow = () => {
    this.setState((prevState, props) => {
      const row = {};
      return { rows: [...prevState.rows, row] };
    });
  };

  handleRemoveRow = () => {
    this.setState((prevState, props) => {
      return { rows: prevState.rows.slice(1) };
    });
  };

  handleRemoveRow1 = () => {
    this.setState((prevState, props) => {
      return { rows: prevState.rows.slice(6) };
    });
  };

  handleRemoveRow2 = () => {
    this.setState((prevState, props) => {
      return { rows: prevState.rows.slice(0) };
    });
  };

  showTypeaheadChange = (e) => {
    const value = e.target.value;
    this.setState({
      quantity: value,
    });
  };

  showTypeahead = (e) => {
    const value = e.target.value;
    this.setState(
      {
        typeaheadText: value,
      },
      () => {
        /*const data_val = ["B-W-R-2" , "C-D-T-3" , "C-D-T-8" , "C-D-T-8"];*/
        this.setState({
          showTypeahead: true,
          zwz_search_pannel: true,
          /* data: data_val*/
        });

         const payload = {
              location: this.state.selectedLocation,
              binAddress: value,
              putawayHistoryId: this.state.putawayHistoryId,
          };

        API.post('/picking/getBins/v1/', { param: payload })
          .then((response) => {
            this.setState({
              data: response.data,
            });
          })
          .catch(function (error) {});
      }
    );
  };

  closeContainer() {
    this.setState({
      showTypeahead: false,
    });
  }

  toggle() {
    this.setState((prevState) => ({ modal: !prevState.modal }));
  }

  Confirmtoggle() {
    this.setState((prevState) => ({ Confirmmodal: !prevState.Confirmmodal }));
  }

  Errortoggle() {
    this.setState((prevState) => ({ Errormodal: !prevState.Errormodal }));
  }

  Successtoggle() {
    this.setState((prevState) => ({ Successmodal: !prevState.Successmodal }));
  }

  showPassword = (e) => {
    e.preventDefault();
    this.setState((prevState) => ({ showPassword: !prevState.showPassword }));
  };

  togglePressCancel() {
    this.setState({
      EditModal: false,
      showICLDReasonCode: false,
      showLOOSEReasonCode: false,
      showTESTERReasonCode: false,
      showMandatoryCrateId: {},
      showMandatoryCrateLoose: {},
      showMandatoryCrateIcld: {},
      showPickCrateLoose: false,
      showPickCrateIcld: false,
      showUpdateLoader: false,
      showPickCrateIcld: false,
      showPickCrateLoose: false,
    });
  }

  CancelBeforeModal() {
    this.setState({
      modalbeforeConfirm: false,
      isEmptyCrateArr: false,
    });
  }

  handleChange(event) {
    let index = event.nativeEvent.target.selectedIndex;
    let label = event.nativeEvent.target[index].text;
    //console.log(label);
    this.setState({ value: event.target.data, batch_id: event.target.value, label_val: label });

    localStorage.setItem("fileName", label);

    //this.fetchGRNData();
  }

  submitClick = () => {
    this.fetchGRNData();
  };

  componentWillMount() {
    if (window.location.port == 8091 || window.location.port === ":8090") {
      port = ":8090";
    }else if (window.location.port == 8098 || window.location.port === ":8098") {
      port = ":8099";
    } else {
      port = ":8088";
    }

    if (url === "localhost") {
      url = "15.206.34.41" + ":8088";
    } else {
      url = window.location.hostname + port;
    }

    var cookieUsername = this.getCookie("token");
    var Location = this.getCookie("selectedLocation");
    var username = this.accessCookie("token");
    var picking_app = this.accessCookie("picking_app_flag");
    var emp_role = this.accessCookie("emp_role");
    
    this.setState({
      userName: cookieUsername,
      selectedLocation: Location,
      picking_app : picking_app,
      emp_role : emp_role
    });

    localStorage.setItem("userName", username);
  }

  accessCookie(cookieName) {
    var name = cookieName + "=";
    var allCookieArray = document.cookie.split(";");
    for (var i = 0; i < allCookieArray.length; i++) {
      var temp = allCookieArray[i].trim();
      if (temp.indexOf(name) == 0)
        return temp.substring(name.length, temp.length);
    }
    return "";
  }

  getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  componentDidMount() {
    this.fetchReason();
    
    const payload = {
      location: this.state.selectedLocation,
      picksheetType: 2,
  };

API.post('/picking/fetchPicksheetList/v1/', { param: payload })
      .then((response) => {
        this.setState({
          schemas: response.data,
        });
      })
      .catch(function (error) {});

    /*this.fetchGRNData();*/
  }

  downloadExcel = () => {
    var fileNameValue = localStorage.getItem("fileName");
    //var filename_array = fileNameValue.split("-");
    //var ptl_id = filename_array[filename_array.length -1];

    const payload = {
      ptl_id: fileNameValue,
      location: this.state.selectedLocation,
  };

API.post('/picking/pickingConfirmedReport/v1/', { param: payload })
      .then((response) => response.data)
      .then((data) => {
        this.setState({ downloadData: data });
        this.exportToCSV(fileNameValue);
      });
  };

  fetchGRNData = () => {
    var checkboxes = document.getElementsByName("select_all_checkbox");
    this.setState({loading_overlay:true});
    for (var i = 0; i < checkboxes.length; i++) {
      if (checkboxes[i].checked == true) {
        document.getElementsByName(checkboxes[i].name)[0].click();
      }
    }
    var fileNameValue = localStorage.getItem("fileName");
    if (
      fileNameValue.indexOf("carton") > -1 ||
      fileNameValue.indexOf("OUTER") > -1 ||
	  fileNameValue.indexOf("BREAKPACK") > -1
    ) {
      this.setState({
        column_type: "carton",
      
      });
      this.setState({
        columns: [
          {
            label: (
              <input
                type="checkbox"
                name="select_all_checkbox"
                selected={false}
                checked = {true}
              disabled = {true}
                onChange={this.handleallCheckBoxClick}
              />
            ),
            name: "checkbox",
          },
          {
            label: "S No.",
            name: "serial",
          },
          {
            label: "BIN Id",
            name: "binId",
          },
          {
            label: "Order Id",
            name: "OrderId",
          },
          {
            label: "Zone Name",
            name: "zone_name",
          },
          /*{
            label: "Zone Id",
            name: "zone_id",
          },*/
          {
            label: "LB SKU ID",
            name: "lbskuid",
          },
          {
            label: "MRP",
            name: "mrp",
          },
          {
            label: "CBU Code",
            name: "cbuCode",
          },
          {
            label: "To Pick Icld Quantity (Box)",
            name: "toPickIcldQty",
          },
          {
            label: "To Pick Loose Quantity (pcs)",
            name: "toPickLooseQty",
          },
          /*{
            label: " To Pick Tester Quantity (pcs)",
            name: "toPickTesterQty",
          },*/
          {
            label: "Picked Icld Quantity (Box)",
            name: "PickIcldQty",
          },
          {
            label: "Picked Loose Quantity (pcs)",
            name: "PickLooseQty",
          },
          /*{
            label: "Picked Tester Quantity (pcs)",
            name: "PickTesterQty",
          },*/
          {
            label: "PKD",
            name: "pkd",
          },
          {
            label: "Action",
            name: "action",
          },
        ],
      });
    } else {
      this.setState({
        column_type: "",
      });
      this.setState({
        columns: [
          {
            label: (
              <input
                type="checkbox"
                name="select_all_checkbox"
                selected={false}
                checked = {true}
              disabled = {true}
                onChange={this.handleallCheckBoxClick}
              />
            ),
            name: "checkbox",
          },
          {
            label: "S No.",
            name: "serial",
          },
          {
            label: "BIN Id",
            name: "binId",
          },
          {
            label: "Zone Name",
            name: "zone_name",
          },
          /*{
            label: "Zone Id",
            name: "zone_id",
          },*/
          {
            label: "LB SKU ID",
            name: "lbskuid",
          },
          {
            label: "MRP",
            name: "mrp",
          },
          {
            label: "CBU Code",
            name: "cbuCode",
          },
          {
            label: "To Pick Icld Quantity (Box)",
            name: "toPickIcldQty",
          },
          {
            label: "To Pick Loose Quantity (pcs)",
            name: "toPickLooseQty",
          },
          {
            label: " To Pick Tester Quantity (pcs)",
            name: "toPickTesterQty",
          },
          {
            label: "Picked Icld Quantity (Box)",
            name: "PickIcldQty",
          },
          {
            label: "Picked Loose Quantity (pcs)",
            name: "PickLooseQty",
          },
          {
            label: "Picked Tester Quantity (pcs)",
            name: "PickTesterQty",
          },
          {
            label: "PKD",
            name: "pkd",
          },
          {
            label: "Action",
            name: "action",
          },
        ],
      });
    }
    this.setState({
      loading: true,
      postsGRN: [],
      tableRowsGRN: [],
      tableRowsGRNTester: [],
    });

    const payload = {
      fileName: this.state.label_val,
      batch_id: this.state.batch_id,
      pickType: 3,
      location: this.state.selectedLocation,
  };
   addAnalytics('Picking Confirmation', 'Picking Confirmation Filter', payload);
API.post('/picking/fetchPicksheetInfo/v1/', { param: payload })
      .then((response) => response.data)
      .then((data) => {
         let newData = data.map((item) => ({
        ...item,
        isChecked: true,
      }));
        this.setState({ postsGRN: newData });
        this.setState({loading_overlay:false});
        // this.disableConfirm();

        if (this.state.postsGRN[0].pickType === "LOOSE") {
          this.setState({
            columns: [
              {
                label: (
                  <input
                    type="checkbox"
                    name="select_all_checkbox"
                    selected={false}
                    onChange={this.handleallCheckBoxClick}
                  />
                ),
                name: "checkbox",
              },
              {
                label: "S No.",
                name: "serial",
              },
              {
                label: "BIN Id",
                name: "binId",
              },
              {
                label: "Zone Name",
                name: "zone_name",
              },
              /*{
            label: "Zone Id",
            name: "zone_id",
          },*/
              {
                label: "LB SKU ID",
                name: "lbskuid",
              },
              {
                label: "MRP",
                name: "mrp",
              },
              {
                label: "CBU Code",
                name: "cbuCode",
              },
              {
                label: "To Pick Icld Quantity (Box)",
                name: "toPickIcldQty",
              },
              {
                label: "To Pick Loose Quantity (pcs)",
                name: "toPickLooseQty",
              },
              {
                label: "Picked Icld Quantity (Box)",
                name: "PickIcldQty",
              },
              {
                label: "Picked Loose Quantity (pcs)",
                name: "PickLooseQty",
              },
              {
                label: "PKD",
                name: "pkd",
              },
              {
                label: "Action",
                name: "action",
              },
            ],
          });
        }

        if (this.state.postsGRN[0].pickType === "ICLD") {
          this.setState({
            columns: [
              {
                label: (
                  <input
                    type="checkbox"
                    name="select_all_checkbox"
                    selected={false}
                    onChange={this.handleallCheckBoxClick}
                  />
                ),
                name: "checkbox",
              },
              {
                label: "S No.",
                name: "serial",
              },
              {
                label: "BIN Id",
                name: "binId",
              },
              {
                label: "Zone Name",
                name: "zone_name",
              },
              /*{
            label: "Zone Id",
            name: "zone_id",
          },*/
              {
                label: "LB SKU ID",
                name: "lbskuid",
              },
              {
                label: "MRP",
                name: "mrp",
              },
              {
                label: "CBU Code",
                name: "cbuCode",
              },
              {
                label: "To Pick Icld Quantity (Box)",
                name: "toPickIcldQty",
              },
              {
                label: "Picked Icld Quantity (Box)",
                name: "PickIcldQty",
              },
              {
                label: "PKD",
                name: "pkd",
              },
              {
                label: "Action",
                name: "action",
              },
            ],
          });
        }

        if (this.state.postsGRN.length > 0) {
          if (this.state.postsGRN[0].pickType === "TESTER") {
            var fileNameValue = localStorage.getItem("fileName");

            if (fileNameValue.indexOf("LOOSE") > -1) {
              this.setState({
                columnsTester: [
                  {
                    label: (
                      <input
                        type="checkbox"
                        name="select_all_checkbox"
                        selected={false}
                        onChange={this.handleallCheckBoxClick}
                      />
                    ),
                    name: "checkbox",
                  },
                  {
                    label: "S No.",
                    name: "serial",
                  },
                  {
                    label: "BIN Id",
                    name: "binId",
                  },
                  {
                    label: "BasePack Code",
                    name: "basepackCode",
                  },
                  {
                    label: "Zone Name",
                    name: "zone_name",
                  },
                  /*{
          label: "Zone Id",
          name: "zone_id",
        },*/
                  {
                    label: "LB SKU ID",
                    name: "lbskuid",
                  },
                  {
                    label: "MRP",
                    name: "mrp",
                  },
                  {
                    label: "CBU Code",
                    name: "cbuCode",
                  },

                  {
                    label: " To Pick Tester Quantity (pcs)",
                    name: "toPickTesterQty",
                  },

                  {
                    label: "Picked Tester Quantity (pcs)",
                    name: "PickTesterQty",
                  },

                  {
                    label: "Action",
                    name: "action",
                  },
                ],
              });
            }

            if (fileNameValue.indexOf("TESTER") > -1) {
              this.setState({
                columnsTester: [
                  {
                    label: (
                      <input
                        type="checkbox"
                        name="select_all_checkbox"
                        selected={false}
                        onChange={this.handleallCheckBoxClick}
                      />
                    ),
                    name: "checkbox",
                  },
                  {
                    label: "S No.",
                    name: "serial",
                  },
                  {
                    label: "BIN Id",
                    name: "binId",
                  },
                  {
                    label: "BasePack Code",
                    name: "basepackCode",
                  },
                  {
                    label: "Zone Name",
                    name: "zone_name",
                  },
                  /*{
          label: "Zone Id",
          name: "zone_id",
        },*/
                  {
                    label: "LB SKU ID",
                    name: "lbskuid",
                  },
                  {
                    label: "MRP",
                    name: "mrp",
                  },
                  {
                    label: "CBU Code",
                    name: "cbuCode",
                  },
                  {
                    label: "Party Name",
                    name: "partyName",
                  },
                  {
                    label: " To Pick Tester Quantity (pcs)",
                    name: "toPickTesterQty",
                  },
                  {
                    label: "Picked Tester Quantity (pcs)",
                    name: "PickTesterQty",
                  },
                  {
                    label: "Action",
                    name: "action",
                  },
                ],
              });
            }
            this.setState({
              showFetchGRNData: false,
              showFetchGRNDataTester: true,
            });
          } else {
            this.setState({
              showFetchGRNData: true,
              showFetchGRNDataTester: false,
            });
          }
        } else {
          this.setState({
            showFetchGRNData: true,
            showFetchGRNDataTester: false,
          });
        }
      })

      .then(async (evt) => {
        if (this.state.showFetchGRNData) {
          this.setState({
            tableRowsGRN: this.assemblePostsGRN(evt),
            isLoading: false,
            loading: false,
          });
        } else {
          this.setState({
            tableRowsGRNTester: this.assemblePostsGRNTester(),
            isLoading: false,
            loading: false,
          });
        }

        
      });
  };

  handleCheckBoxClick = (e) => {
    const selected = this.state.selected;
    selected[e.target.name] = e.target.checked;
    this.setState({ selected }, () => {
      var sp_checked_status = [];
	  var cancel_checked_status = [];
      for (let pickHistId in this.state.selected) {
        if (this.state.selected[pickHistId] == true) {
		  let reqId = pickHistId.split("_")[0];
          sp_checked_status.push(reqId);
		  cancel_checked_status.push(pickHistId.split("_")[1]);
        }
      }

      if (sp_checked_status.length > 0) {
        this.setState({
          cancelDisableBtn: false,
          pickHisIdToCancel: cancel_checked_status,
        });
      } else {
        this.setState({
          cancelDisableBtn: true,
          pickHisIdToCancel: cancel_checked_status,
        });
      }
    });
  };

  handleallCheckBoxClick = (e) => {
    const selected_all = e.target.checked;
    const selected = this.state.selected;

    const checkboxes = document.getElementsByClassName("checkbox_div");

    for (var i = 0; i < checkboxes.length; i++) {
      if (checkboxes[i].disabled == false) {
        if (checkboxes[i].checked != e.target.checked) {
          document.getElementsByName(checkboxes[i].name)[0].click();
        }
      }
    }

    this.setState(
      {
        selected: selected,
      },
      () => {
        var sp_checked_status = [];
		var cancel_checked_status = [];
        for (let pickHistId in this.state.selected) {
          if (this.state.selected[pickHistId] == true) {
			let reqId = pickHistId.split("_")[0];
            sp_checked_status.push(reqId);
			cancel_checked_status.push(pickHistId.split("_")[1]);
          }
        }

        if (sp_checked_status.length > 0) {
          this.setState({
            cancelDisableBtn: false,
            pickHisIdToCancel: cancel_checked_status,
          });
        } else {
          this.setState({
            cancelDisableBtn: true,
            pickHisIdToCancel: cancel_checked_status,
          });
        }
      }
    );

    this.setState({
      selected_all: selected_all,
    });
  };
  
  handleShortPickingCheckBoxClick = (e) => {
    const selected = this.state.short_picking_selected;
    selected[e.target.name] = e.target.checked;
    this.setState({ selected }, () => {
      var sp_checked_status = [];
      for (let pickHistId in this.state.short_picking_selected) {
        if (this.state.short_picking_selected[pickHistId] == true) {
          sp_checked_status.push(pickHistId);
        }
      }

      if (sp_checked_status.length > 0) {
        this.setState({ sp_proceed_btn_disabled: false });
      } else {
        this.setState({ sp_proceed_btn_disabled: true });
      }
    });
  };

  handleallShortPickingCheckBoxClick = (e) => {
    const selected_all = e.target.checked;
    const selected = this.state.short_picking_selected;

    const checkboxes = document.getElementsByClassName("checkbox_div");

    for (var i = 0; i < checkboxes.length; i++) {
      if (checkboxes[i].disabled == false) {
        if (checkboxes[i].checked != e.target.checked) {
          document.getElementsByName(checkboxes[i].name)[0].click();
        }
      }
    }

    this.setState(
      {
        short_picking_selected: selected,
      },
      () => {
        var sp_checked_status = [];
        for (let pickHistId in this.state.short_picking_selected) {
          if (this.state.short_picking_selected[pickHistId] == true) {
            sp_checked_status.push(pickHistId);
          }
        }

        if (sp_checked_status.length > 0) {
          this.setState({ sp_proceed_btn_disabled: false });
        } else {
          this.setState({ sp_proceed_btn_disabled: true });
        }
      }
    );
    this.setState({
      short_picking_selected_all: selected_all,
    });
  };

  assemblePostsGRN = (event) => {
    //this.handleallCheckBoxClick(event)
    let same_grouped_data = [];
    let data = [];
    var blank_details = {};
    var table_row = {};
    var index = 0;
    var checkbox_html = "";
    var checkbox_classname = "";

    let items = this.state.postsGRN.sort(function (a, b) {
      var textA = a.pickRequestId;
      var textB = b.pickRequestId;
      return textA < textB ? -1 : textA > textB ? 1 : 0;
    });

    var pickingConfrimId = [];
    var confirmation_pending_ids = [];
    var pickingPendingId = [];
    var shortPickingRows = [];
    var shortPickingpickReqID = [];
    var stock_available_not_zero = [];

    let allpickHistCrateDetail = { ...this.state.table_row };
	
    for (let i = 0; i < items.length; i++) {
	   if(items[i]["parentmerge"] === true){
		continue
	  }
      index += 1;
      if (
        Object.keys(allpickHistCrateDetail).indexOf(
          items[i]["pickingHistoryId"].toString()
        ) <= -1
      ) {
        allpickHistCrateDetail[items[i]["pickingHistoryId"]] = [1];
      }

      if (
        items[i]["pickingConfrimId"] != undefined &&
        items[i]["pickingConfrimId"] != null
      ) {
        if (parseInt(items[i]["putaway"]) == 1) {
          pickingConfrimId.push(items[i]["pickingConfrimId"]);
        }
      }

      /*if (parseInt(items[i]["picking_pending"]) != 0) {
        var checkbox_name = index + "_" + items[i]["pickRequestId"];
        var checkbox_html = (
          <input
            type="checkbox"
            name={checkbox_name}
            className="checkbox_div"
            selected={this.state.short_picking_selected[checkbox_name]}
            onChange={this.handleShortPickingCheckBoxClick}
          />
        );
        table_row = {
          checkbox: checkbox_html,
          lbSkuId: items[i]["lbSkuId"],
          productName: items[i]["productName"],
          pkd: items[i]["pkd"],
          cbuCode: items[i]["cbuCode"],
          basePackCode: items[i]["basePackCode"],
          pending: items[i]["picking_pending"],
          stock: items[i]["stock_available"],
        };
    
    if (parseInt(items[i]["stock_available"]) != 0) {
        stock_available_not_zero.push(items[i]["picking_pending"]);
    }
    
        //if (parseInt(items[i]["stock_available"]) != 0) {
          pickingPendingId.push(items[i]["picking_pending"]);
        //}
        if (shortPickingpickReqID.indexOf(items[i]["pickRequestId"]) <= -1) {
          shortPickingRows.push(table_row);
          shortPickingpickReqID.push(items[i]["pickRequestId"]);
        }
      }*/

      if (parseInt(items[i]["picking_pending"]) != 0) {
        pickingPendingId.push(items[i]["picking_pending"]);
      }

      /*if(items[i]["orderType"] == "0"){
      var firstobj = items[i]["OrderId"]+items[i]["lbSkuId"]+items[i]["pkd"];
    }else{
      var firstobj = items[i]["lbSkuId"]+items[i]["pkd"];
    }*/
      var firstobj = items[i]["pickRequestId"]+"_"+items[i]["pickingHistoryId"];
      var checkbox_enabled_arr = [];

      if (same_grouped_data.indexOf(firstobj) == -1) {
        checkbox_classname = "checkbox_div checkbox_" + firstobj;

        if (items[i]["editFlag"] == 0) {
          checkbox_html = (
            <input
              type="checkbox"
              disabled = {true}
              checked = {true}
              className={checkbox_classname}
              name={firstobj}
              selected={this.state.selected[checkbox_classname]}

              style={{ }}
            
            />
          );

          confirmation_pending_ids.push(items[i]["pickRequestId"]);
        } else {
          for (let j = 0; j < items.length; j++) {
            if (
              items[i]["pickRequestId"] == items[j]["pickRequestId"] &&
              items[j]["editFlag"] == 0
            ) {
              checkbox_enabled_arr.push(firstobj);
            }
          }

          if (checkbox_enabled_arr.length > 0) {
            checkbox_html = (
              <input
                type="checkbox"
                className={checkbox_classname}
                checked = {true}
                name={firstobj}
                selected={this.state.selected[checkbox_classname]}
                onChange={this.handleCheckBoxClick}
              
              />
            );
          } else {
            checkbox_html = (
              <input
                type="checkbox"

                checked = {true}
                style={{cursor: "not-allowed" }}
                name={firstobj}
                selected={this.state.selected[checkbox_classname]}
                className={checkbox_classname}
                onChange={this.handleCheckBoxClick}
              />
            );
          }
        }

        same_grouped_data.push(firstobj);
      } else {
        if (items[i]["editFlag"] == 0) {
          confirmation_pending_ids.push(items[i]["pickRequestId"]);
        }
        checkbox_html = (
          <input
            type="checkbox"

            checked = {true}
            style={{
              cursor: "not-allowed",
            }}
            name={firstobj}
            selected={this.state.selected[checkbox_classname]}
            className={checkbox_classname}
            onChange={this.handleCheckBoxClick}
          />
        );
      }

      if (confirmation_pending_ids.length == 0) {
        this.setState({
          editBtnFlag: false,
          disabledBtn: true,
        });

        if (pickingConfrimId.length == 0) {
          this.setState({
            putawayBtnflag: false,
          });
        } else {
          this.setState({
            putawayBtnflag: true,
          });
        }
      } else {
        this.setState({
          editBtnFlag: true,
          disabledBtn: false,
        });
      }

      if (pickingPendingId.length > 0) {
        this.setState({
          pendingBtnflag: true,
        });
      } else {
        this.setState({
          pendingBtnflag: false,
        });
      }

      /*if(stock_available_not_zero.length > 0){
    this.setState({
      stock_available_not_zero:false
    });
    }else{
     this.setState({
      stock_available_not_zero:true
    }); 
    }*/
      if (this.state.column_type == "carton") {
        table_row = {
          checkbox: <input
              type="checkbox"
              disabled = {true}
              checked =  {items[i]["isChecked"]}
              className={checkbox_classname}
              name={firstobj}
              selected={this.state.selected[checkbox_classname]}

              style={{ }}
            
            />,
          serial: index,
          binId: items[i]["binAddress"],
          OrderId: items[i]["OrderId"],
          zone_name: items[i]["zoneName"],
          //zone_id: items[i]["zoneId"],
          lbskuid: items[i]["lbSkuId"],
          mrp: items[i]["mrp"],
          cbuCode: items[i]["cbuCode"],
          toPickIcldQty: items[i]["toPickIcldQty"],
          toPickLooseQty: items[i]["toPickLooseQty"],
          toPickTesterQty: items[i]["toPickTesterQty"],
          PickIcldQty: items[i]["pickedIcldQty"],
          PickLooseQty: items[i]["pickedLooseQty"],
          PickTesterQty: items[i]["pickedTesterQty"],
          pkd: items[i]["pkd"],
          action:
            items[i]["editFlag"] == 0 ? (
              <span
                onClick={(r) =>
                  this.btnClick(
                    items[i]["lbSkuId"],
                    items[i]["pkd"],
                    items[i]["mrp"],
                    items[i]["binAddress"],
                    items[i]["pickingHistoryId"],
                    items[i]["pickedIcldQty"],
                    items[i]["pickedLooseQty"],
                    items[i]["pickedTesterQty"],
                    items[i]["toPickIcldQty"],
                    items[i]["toPickLooseQty"],
                    items[i]["toPickTesterQty"],
                    items[i]["upc"],
                    items[i]["sheetType"],
                    items[i]["ocldFlag"]
                  )
                }
                style={{ cursor: "pointer", color: "#3ea3fc" }}
              >
                Edit
              </span>
            ) : (
              <span
                style={{ opacity: "0.65", cursor: "not-allowed" }}
                disabled="disabled"
              >
                Edit
              </span>
            ),
        };
      } else {
        table_row = {
          checkbox: <input
              type="checkbox"
              disabled = {true}
              checked = {items[i]["isChecked"]}
              className={checkbox_classname}
              name={firstobj}
              selected={this.state.selected[checkbox_classname]}

              style={{ }}
            
            />,
          serial: index,
          binId: items[i]["binAddress"],
          zone_name: items[i]["zoneName"],
          //zone_id: items[i]["zoneId"],
          lbskuid: items[i]["lbSkuId"],
          mrp: items[i]["mrp"],
          cbuCode: items[i]["cbuCode"],
          toPickIcldQty: items[i]["toPickIcldQty"],
          toPickLooseQty: items[i]["toPickLooseQty"],
          toPickTesterQty: items[i]["toPickTesterQty"],
          PickIcldQty: items[i]["pickedIcldQty"],
          PickLooseQty: items[i]["pickedLooseQty"],
          PickTesterQty: items[i]["pickedTesterQty"],
          pkd: items[i]["pkd"],
          action:
            items[i]["editFlag"] == 0 ? (
              <span
                onClick={(r) =>
                  this.btnClick(
                    items[i]["lbSkuId"],
                    items[i]["pkd"],
                    items[i]["mrp"],
                    items[i]["binAddress"],
                    items[i]["pickingHistoryId"],
                    items[i]["pickedIcldQty"],
                    items[i]["pickedLooseQty"],
                    items[i]["pickedTesterQty"],
                    items[i]["toPickIcldQty"],
                    items[i]["toPickLooseQty"],
                    items[i]["toPickTesterQty"],
                    items[i]["upc"],
                    items[i]["sheetType"],
                    items[i]["ocldFlag"]
                  )
                }
                style={{ cursor: "pointer", color: "#3ea3fc" }}
              >
                Edit
              </span>
            ) : (
              <span
                style={{ opacity: "0.65", cursor: "not-allowed" }}
                disabled="disabled"
              >
                Edit
              </span>
            ),
        };
      }

      data.push(table_row);
    }

    this.setState({
      pickingConfrimId: pickingConfrimId,
      table_row: allpickHistCrateDetail,
    });
    return data;
  };

  assemblePostsGRNTester = () => {
    let same_grouped_data = [];
    let data = [];
    var blank_details = {};
    var table_row = {};
    var index = 0;
    var checkbox_html = "";
    var checkbox_classname = "";

    let items = this.state.postsGRN.sort(function (a, b) {
      var textA = a.pickRequestId;
      var textB = b.pickRequestId;
      return textA < textB ? -1 : textA > textB ? 1 : 0;
    });

    var pickingConfrimId = [];
    var confirmation_pending_ids = [];
    var pickingPendingId = [];
    var shortPickingRows = [];
    var shortPickingpickReqID = [];
    var checkbox_enabled_arr = [];
    var stock_available_not_zero = [];

    let allpickHistCrateDetail = { ...this.state.table_row };

    for (let i = 0; i < items.length; i++) {
       if(items[i]["parentmerge"] === true){
		continue
	  }
      index += 1;
      if (
        Object.keys(allpickHistCrateDetail).indexOf(
          items[i]["pickingHistoryId"].toString()
        ) <= -1
      ) {
        allpickHistCrateDetail[items[i]["pickingHistoryId"]] = [1];
      }

      if (
        items[i]["pickingConfrimId"] != undefined &&
        items[i]["pickingConfrimId"] != null
      ) {
        if (parseInt(items[i]["putaway"]) == 1) {
          pickingConfrimId.push(items[i]["pickingConfrimId"]);
        }
      }

      /*if (parseInt(items[i]["picking_pending"]) != 0) {
        var checkbox_name = index + "_" + items[i]["pickRequestId"];
        var checkbox_html = (
          <input
            type="checkbox"
            name={checkbox_name}
            className="checkbox_div"
            selected={this.state.short_picking_selected[checkbox_name]}
            onChange={this.handleShortPickingCheckBoxClick}
          />
        );
        table_row = {
          checkbox: checkbox_html,
          lbSkuId: items[i]["lbSkuId"],
          productName: items[i]["productName"],
          pkd: items[i]["pkd"],
          cbuCode: items[i]["cbuCode"],
          basePackCode: items[i]["basePackCode"],
          pending: items[i]["picking_pending"],
          stock: items[i]["stock_available"],
        };
  
        if (parseInt(items[i]["stock_available"]) != 0) {
        stock_available_not_zero.push(items[i]["picking_pending"]);
    }
          pickingPendingId.push(items[i]["picking_pending"]);
        //}
    
        if (shortPickingpickReqID.indexOf(items[i]["pickRequestId"]) <= -1) {
          shortPickingRows.push(table_row);
          shortPickingpickReqID.push(items[i]["pickRequestId"]);
        }
      }*/

      if (parseInt(items[i]["picking_pending"]) != 0) {
        pickingPendingId.push(items[i]["picking_pending"]);
      }
      /*if(items[i]["orderType"] == "0"){
      var firstobj = items[i]["OrderId"]+items[i]["basePackCode"];
    }else{
      var firstobj = items[i]["basePackCode"];
    }*/

      var firstobj = items[i]["pickRequestId"]+"_"+items[i]["pickingHistoryId"];
      if (same_grouped_data.indexOf(firstobj) == -1) {
        checkbox_classname = "checkbox_div checkbox_" + firstobj;

        if (items[i]["editFlag"] == 0) {
          checkbox_html = (
            <input
              type="checkbox"
              className={checkbox_classname}
              name={firstobj}
              selected={this.state.selected[checkbox_classname]}
              onChange={this.handleCheckBoxClick}
              style={{ opacity: "0.85" }}
            />
          );

          confirmation_pending_ids.push(items[i]["pickRequestId"]);
        } else {
          for (let j = 0; j < items.length; j++) {
            if (
              items[i]["pickRequestId"] == items[j]["pickRequestId"] &&
              items[j]["editFlag"] == 0
            ) {
              checkbox_enabled_arr.push(firstobj);
            }
          }

          if (checkbox_enabled_arr.length > 0) {
            checkbox_html = (
              <input
                type="checkbox"
                className={checkbox_classname}
                name={firstobj}
                selected={this.state.selected[checkbox_classname]}
                onChange={this.handleCheckBoxClick}
                style={{ opacity: "0.85" }}
              />
            );
          } else {
            checkbox_html = (
              <input
                type="checkbox"
                disabled="disabled"
                style={{ opacity: "0.65", cursor: "not-allowed" }}
                name={firstobj}
                selected={this.state.selected[checkbox_classname]}
                className={checkbox_classname}
                onChange={this.handleCheckBoxClick}
              />
            );
          }
        }

        same_grouped_data.push(firstobj);
      } else {
        if (items[i]["editFlag"] == 0) {
          confirmation_pending_ids.push(items[i]["pickRequestId"]);
        }

        checkbox_html = (
          <input
            type="checkbox"
            disabled="disabled"
            style={{
              opacity: "0.65",
              cursor: "not-allowed",
              visibility: "hidden",
            }}
            name={firstobj}
            selected={this.state.selected[checkbox_classname]}
            className={checkbox_classname}
            onChange={this.handleCheckBoxClick}
          />
        );
      }

      if (confirmation_pending_ids.length == 0) {
        this.setState({
          editBtnFlag: false,
          disabledBtn: true,
        });
        if (pickingConfrimId.length == 0) {
          this.setState({
            putawayBtnflag: false,
          });
        } else {
          this.setState({
            putawayBtnflag: true,
          });
        }
      } else {
        this.setState({
          editBtnFlag: true,
          disabledBtn: false,
        });
      }

      if (pickingPendingId.length > 0) {
        this.setState({
          pendingBtnflag: true,
        });
      } else {
        this.setState({
          pendingBtnflag: false,
        });
      }

      /*if(stock_available_not_zero.length > 0){
    this.setState({
      stock_available_not_zero:false
    });
    }else{
     this.setState({
      stock_available_not_zero:true
    }); 
    }*/
      if (this.state.column_type == "carton") {
        table_row = {
          checkbox: checkbox_html,
          serial: index,
          binId: items[i]["binAddress"],
          OrderId: items[i]["OrderId"],
          basepackCode: items[i]["basePackCode"],
          zone_name: items[i]["zoneName"],
          //zone_id: items[i]["zoneId"],
          lbskuid: items[i]["lbSkuId"],
          // pickType: items[i]["pickType"],
          mrp: items[i]["mrp"],
          cbuCode: items[i]["cbuCode"],
          partyName: items[i]["party_name"],
          toPickIcldQty: items[i]["toPickIcldQty"],
          toPickLooseQty: items[i]["toPickLooseQty"],
          toPickTesterQty: items[i]["toPickTesterQty"],
          PickIcldQty: items[i]["pickedIcldQty"],
          PickLooseQty: items[i]["pickedLooseQty"],
          PickTesterQty: items[i]["pickedTesterQty"],
          pkd: items[i]["pkd"],
          action:
            items[i]["editFlag"] == 0 ? (
              <span
                onClick={(r) =>
                  this.btnClick(
                    items[i]["lbSkuId"],
                    items[i]["pkd"],
                    items[i]["mrp"],
                    items[i]["binAddress"],
                    items[i]["pickingHistoryId"],
                    items[i]["pickedIcldQty"],
                    items[i]["pickedLooseQty"],
                    items[i]["pickedTesterQty"],
                    items[i]["toPickIcldQty"],
                    items[i]["toPickLooseQty"],
                    items[i]["toPickTesterQty"],
                    items[i]["upc"],
                    items[i]["sheetType"],
                    items[i]["ocldFlag"]
                  )
                }
                style={{ cursor: "pointer", color: "#3ea3fc" }}
              >
                Edit
              </span>
            ) : (
              <span
                style={{ opacity: "0.65", cursor: "not-allowed" }}
                disabled="disabled"
              >
                Edit
              </span>
            ),
        };
      } else {
        table_row = {
          checkbox: checkbox_html,
          serial: index,
          binId: items[i]["binAddress"],
          basepackCode: items[i]["basePackCode"],
          zone_name: items[i]["zoneName"],
          //zone_id: items[i]["zoneId"],
          lbskuid: items[i]["lbSkuId"],
          // pickType: items[i]["pickType"],
          mrp: items[i]["mrp"],
          cbuCode: items[i]["cbuCode"],
          partyName: items[i]["party_name"],
          toPickIcldQty: items[i]["toPickIcldQty"],
          toPickLooseQty: items[i]["toPickLooseQty"],
          toPickTesterQty: items[i]["toPickTesterQty"],
          PickIcldQty: items[i]["pickedIcldQty"],
          PickLooseQty: items[i]["pickedLooseQty"],
          PickTesterQty: items[i]["pickedTesterQty"],
          pkd: items[i]["pkd"],
          action:
            items[i]["editFlag"] == 0 ? (
              <span
                onClick={(r) =>
                  this.btnClick(
                    items[i]["lbSkuId"],
                    items[i]["pkd"],
                    items[i]["mrp"],
                    items[i]["binAddress"],
                    items[i]["pickingHistoryId"],
                    items[i]["pickedIcldQty"],
                    items[i]["pickedLooseQty"],
                    items[i]["pickedTesterQty"],
                    items[i]["toPickIcldQty"],
                    items[i]["toPickLooseQty"],
                    items[i]["toPickTesterQty"],
                    items[i]["upc"],
                    items[i]["sheetType"],
                    items[i]["ocldFlag"]
                  )
                }
                style={{ cursor: "pointer", color: "#3ea3fc" }}
              >
                Edit
              </span>
            ) : (
              <span
                style={{ opacity: "0.65", cursor: "not-allowed" }}
                disabled="disabled"
              >
                Edit
              </span>
            ),
        };
      }

      data.push(table_row);
    }

    this.setState({
      pickingConfrimId: pickingConfrimId,
      table_row: allpickHistCrateDetail,
    });
    return data;
  };

  btnClick = (
    LBSKUID,
    PKD,
    MRP,
    BinAddress,
    PickingHistoryId,
    ICLDQTY1,
    LOOSEQTY1,
    TESTERQTY1,
    ICLDQTY,
    LOOSEQTY,
    TESTERQTY,
    UPC,
    PickType,
    ocldFlag
  ) => {
    let mandatoryCrateIDs = { ...this.state.showMandatoryCrateId };
    let mandatorycrateLooseQty = { ...this.state.showMandatoryCrateLoose };
    let mandatorycrateIcldQty = { ...this.state.showMandatoryCrateIcld };

    mandatoryCrateIDs[1] = false;
    mandatorycrateLooseQty[1] = false;
    mandatorycrateIcldQty[1] = false;

    if (PickType == "LOOSE") {
      this.setState({
        isDisabledLOOSE: false,
        isDisabledICLD: false,
      });
    }else if(PickType == "NPP"){
       this.setState({
        isDisabledLOOSE: false,
        isDisabledICLD: false,
      });
    }
    else if(PickType == "Loose(NonPTL)"){
       this.setState({
        isDisabledLOOSE: false,
        isDisabledICLD: false,
      });
    }
     else if (PickType == "CLD") {
      this.setState({
        isDisabledICLD: false,
        isDisabledLOOSE: true,
      });
    } else if (PickType == "TESTER") {
      this.setState({
        isDisabledICLD: true,
        isDisabledLOOSE: false,
      });
    } else if (PickType == "OUTER" && ocldFlag.toString() == "0") {
      this.setState({
        isDisabledICLD: false,
        isDisabledLOOSE: true,
      });
    } else if (PickType == "OUTER" && ocldFlag.toString() == "1") {
      this.setState({
        isDisabledLOOSE: false,
        isDisabledICLD: true,
      });
    } else {
      this.setState({
        isDisabledLOOSE: true,
        isDisabledICLD: true,
      });
    }

    let reason_code = { ...this.state.reason_code };
    if (Object.keys(reason_code).indexOf(PickingHistoryId.toString()) <= -1) {
      reason_code[PickingHistoryId] = "";
    }

    this.setState(
      {
        EditModal: true,
        /* typeaheadText: binId,*/
        pickingHistoryId: PickingHistoryId,
        binId: BinAddress,
        pkd_val: PKD,
        lbskuid_val: LBSKUID,
        mrp_val: MRP,
        icldQty1: ICLDQTY1,
        looseQty1: LOOSEQTY1,
        testerQty1: TESTERQTY1,
        icldQty: ICLDQTY,
        looseQty: LOOSEQTY,
        testerQty: TESTERQTY,
        checkicldQty: ICLDQTY,
        checklooseQty: LOOSEQTY,
        upcQty: UPC,
        PickType: PickType,
        checktesterQty: TESTERQTY,
        showTesterError: false,
        showICLDError: false,
        showLooseError: false,
        showMandatoryCrateId: mandatoryCrateIDs,
        showMandatoryCrateLoose: mandatorycrateLooseQty,
        showMandatoryCrateIcld: mandatorycrateIcldQty,
        reason_code: reason_code,
      },
      () => {
      }
    );
  };

  beforeConfirm() {

    

    this.setState({
      selectedUser: {},
      modalbeforeConfirm: true,
      newArrayData: [],
    });

    var selected = {};
    var selected_arr = Object.keys(this.state.selected);
    for (let i = 0; i < selected_arr.length; i++) {
      if (this.state.selected[selected_arr[i]] == true) {
        selected[selected_arr[i]] = true;
      }
    }

    this.setState(
      {
        selected: selected,
      },
      () => {
        var arrayCartData = [...this.state.postsGRN];

        for (let i = 0; i < arrayCartData.length; i++) {
          if (arrayCartData[i] != undefined) {
            var firstobj = arrayCartData[i]["pickRequestId"]+"_"+arrayCartData[i]["pickingHistoryId"];

            if (
              Object.keys(this.state.selected).indexOf(firstobj.toString()) ==
              -1
            ) {
              delete arrayCartData[i];
            }
          }
        }

        this.setState({
          newArrayData: this.state.postsGRN,
        });
      }
    );
  }

  processData() {
    var orderData = {};

    orderData["binAddress"] = this.state.typeaheadText;
    orderData["newPutawayQty"] = this.state.quantity;
    this.state.splitData.push(orderData);

    var total_Quantity = this.state.quantity;

    for (var i = 0; i < this.state.rows.length; i++) {
      var neworderData = {};
      neworderData["binAddress"] = this.state.rows[i].binId;
      neworderData["newPutawayQty"] = this.state.rows[i].qty;

      total_Quantity =
        parseInt(total_Quantity) + parseInt(this.state.rows[i].qty);

      this.state.splitData.push(neworderData);
    }

    /*if (this.state.defaultquantity < total_Quantity) {
      
      this.setState({
        ErrorMessage: 'Total quantity split exceeds the available quantity',
        Errormodal: true,
      })

      return false;
    }*/

    const payload = {
      putawayHistoryId: this.state.putawayHistoryId,
      newPutaway: this.state.splitData,
      location: this.state.selectedLocation,
  };

API.post('/picking/splitPutaway/v1/', { param: payload })
      .then((response) => {
        if (response.data.success_response.length > 0) {
          this.setState({
            schemas: response.data,
            modal: false,
            Successmodal: true,
            ErrorMessage: "Successfully Updated",
            rows: [],
            splitData: [],
          });

          this.fetchGRNData();
        } else if (response.data.failure_response.length > 0) {
          this.handleRemoveRow2();
          this.setState({
            ErrorMessage: response.data.failure_response[0].reason,
            Errormodal: true,
            /*rows: [],*/
            splitData: [],
          });
        }
      })
      .catch(function (error) {});

    /*console.log(this.state.splitData);*/
  }

  getMuiTheme = () =>
    createMuiTheme({
      overrides: {
        MUIDataTable: {
          root: {
            border: "none !important",
          },
          paper: {
            boxShadow: "none",
          },
        },
        MUIDataTableToolbar: {
          root: {
            minHeight: "0px",
          },
        },
        MUIDataTableHeadCell: {
          root: {
            padding: "25px",
            border: "none !important",
            textAlign: "center",
            color: "#646777",
          },
        },
        MUIDataTableBodyCell: {
          root: {
            padding: "2px !important",
            border: "none",
            textAlign: "center",
            color: "#646777",
          },
        },
      },
    });

  addTableRowInTable = () => {
    let table_row = this.state.table_row;
    let table_row_length = parseInt(
      table_row[this.state.pickingHistoryId].length
    );
    let last_element_int =
      parseInt(table_row[this.state.pickingHistoryId][table_row_length - 1]) +
      1;
    table_row[this.state.pickingHistoryId].push(last_element_int);

    let mandatoryCrateIDs = { ...this.state.showMandatoryCrateId };
    let mandatorycrateLooseQty = { ...this.state.showMandatoryCrateLoose };
    let mandatorycrateIcldQty = { ...this.state.showMandatoryCrateIcld };

    mandatoryCrateIDs[last_element_int] = false;
    mandatorycrateLooseQty[last_element_int] = false;
    mandatorycrateIcldQty[last_element_int] = false;

    this.setState({
      table_row_flag: !this.state.table_row_flag,
      table_row: table_row,
      showMandatoryCrateId: mandatoryCrateIDs,
      showMandatoryCrateLoose: mandatorycrateLooseQty,
      showMandatoryCrateIcld: mandatorycrateIcldQty,
    });
  };

  deleteClickedRow = () => {
    let table_row = this.state.table_row;

    table_row[this.state.pickingHistoryId].pop();

    this.setState({
      table_row: table_row,
    });
    this.setState({
      table_row_flag: !this.state.table_row_flag,
    });
  };

  toggleLBSKUID = () => {
    this.setState({
      lbsku_editable: true,
    });
  };

  onChangeLBSKU = (e) => {
    this.setState({
      lbskuid_val: e.target.value,
    });
  };
  updateLBSKUID = () => {
    this.setState({
      lbsku_editable: false,
    });
  };

  cancelPickingHistory = () => {
    this.setState({
      pickingHisCancel: !this.state.pickingHisCancel,
    });
  };

  cancelBtnHandler = () => {
	 
    const selected = this.state.selected;
    const checkboxes = document.getElementsByClassName("checkbox_div");

    for (var i = 0; i < checkboxes.length; i++) {
      if (checkboxes[i].disabled == false) {
        if (checkboxes[i].checked === true) {
          document.getElementsByName(checkboxes[i].name)[0].click();
        }
      }
    }

    this.setState(
      {
        selected: selected,
        selected_all: false,
        pickingHisCancel: !this.state.pickingHisCancel,
      },
      () => {
        var sp_checked_status = [];
        for (let pickHistId in this.state.selected) {
          if (this.state.selected[pickHistId] == true) {
            sp_checked_status.push(pickHistId);
          }
        }
        
        if (sp_checked_status.length > 0) {
          this.setState({
            cancelDisableBtn: false,
            pickHisIdToCancel: sp_checked_status,
          });
        } else {
          this.setState({
            cancelDisableBtn: true,
            pickHisIdToCancel: sp_checked_status,
          });
        }
      }
    );
  };

  okHandler = () => {
	this.setState({
	  loading_overlay: true
    })   
    const payload = {
      location: this.state.selectedLocation,
      picking_hist_ids: this.state.pickHisIdToCancel,
  };

API.post('/picking/cancelPickingHist/v1/', { param: payload })
      .then((response) => response.data)
      .then((data) => {
        if(data.status === true){
			this.cancelBtnHandler();
            window.location.reload();
		}
      })
      .catch(function (error) {});
  };

  fetchReason = () => {
    const payload = {
      location: this.state.selectedLocation,
      job_type: "PK",
  };

API.post('/stock/fetchReasons/v1/', { param: payload })
      .then((response) => response.data)
      .then((data) => {
        let reasonDropdown = [...this.state.reasonDropdown];
        
        this.setState({reasonDropdown: data})
      })
      .catch(function (error) {});
  }
  render() {
    const productData = {
      columns: [
      {
          label: (
            <input
              type="checkbox"
              style={{display: 'none'}}
              onChange={this.handleallShortPickingCheckBoxClick}
              selected={false}
            />
          ),
          name: "checkbox",
        },
        {
          label: "LB SKU ID",

          field: "lbSkuId",
          sort: "asc",
          width: 100,
        },
        {
          label: "LB SKU Product Name",

          field: "productName",
          sort: "asc",
          width: 100,
        },
        {
          label: "PKD",

          field: "pkd",
          sort: "asc",
          width: 100,
        },
        {
          label: "CBU Code",
          field: "cbuCode",
          sort: "asc",
          width: 100,
        },
        {
          label: "Basepack Code",
          field: "basePackCode",
          sort: "asc",
          width: 100,
        },
        {
          label: "Pending for Picking",
          field: "pending",
          sort: "asc",
          width: 100,
        },
        {
          label: "Stock Available",
          field: "stock",
          sort: "asc",
          width: 100,
        },
      ],
      rows: this.state.shortPickingRows,
    };

    const { handleSubmit, reset, t } = this.props;
    const { showPassword } = this.state;
    const { modal } = this.state;
    const { Errormodal } = this.state;
    const { Successmodal } = this.state;
    const { Confirmmodal } = this.state;
    const { modalbeforeConfirm } = this.state;
    const { EditModal } = this.state;
    const { ErrorMessagemodal } = this.state;
    const { newArrayData, selectedUser } = this.state;
    var crate_index = -1;

    const uniqueZoneData = {};
    newArrayData.map((item) => {
      if (!uniqueZoneData[item.userId]) {
        uniqueZoneData[item.userId] = {
          zoneId: item.userId,
          zoneName: item.userName,
          date: moment(item.date, "MM-DD-YYYY").valueOf(),
          time: moment(item.time, "HH:mm").valueOf(),
          error: item.error,
          items: [],
        };
      }
      uniqueZoneData[item.userId].items.push(item);
    });

    const GRNData = {
      columns: this.state.columns,
      rows: this.state.tableRowsGRN,
    };

    const GRNDataTester = {
      columns: this.state.columnsTester,
      rows: this.state.tableRowsGRNTester,
    };

    const options = {
      textLabels: {
        body: {
          noMatch: "Data is Loading.....",
        },
      },
      selectableRows: false,
      sort: false,
      download: false,
      print: false,
      viewColumns: false,
      filter: false,
      pagination: false,
      search: true,
      setRowProps: (row) => {
        if (row[1] % 2 == 0) {
          if (row[1] != 1) {
            if (row[0].props.style["visibility"] == undefined) {
              return {
                style: {
                  borderTop: "3px solid #ddd",
                  backgroundColor: "#ffffff",
                  color: "#646777 !important",
                  height: "4px !important",
                },
              };
            } else {
              return {
                style: {
                  borderTop: "none",
                  backgroundColor: "#ffffff",
                  color: "#646777 !important",
                  height: "4px !important",
                },
              };
            }
          }
        } else {
          if (row[1] != 1) {
            if (row[0].props.style["visibility"] == undefined) {
              return {
                style: {
                  borderTop: "3px solid #ddd",
                  backgroundColor: "#f2f4f7",
                  color: "#646777 !important",
                  height: "4px !important",
                },
              };
            } else {
              return {
                style: {
                  borderTop: "none",
                  backgroundColor: "#f2f4f7",
                  color: "#646777 !important",
                  height: "4px !important",
                },
              };
            }
          }
        }
      },
    };

    var reasonCodeMsg = "";
    if (this.state.reason_code[this.state.pickingHistoryId] !== undefined) {
      if (this.state.reason_code[this.state.pickingHistoryId] === "103") {
        reasonCodeMsg = "Perform Cycle Count for the Bin";
      } else if (
        this.state.reason_code[this.state.pickingHistoryId] === "102"
      ) {
        reasonCodeMsg = "Move damaged physical stock to damage zone";
      } else if (
        this.state.reason_code[this.state.pickingHistoryId] === "101"
      ) {
        reasonCodeMsg = "The system will register this as missing ";
      }
      if (this.state.reason_code[this.state.pickingHistoryId] === "104") {
        reasonCodeMsg = "Move the inventory back to the Original Source Bin";
      }
    }

    return (
      <Col xl={12}>
	  {this.state.loading_overlay && <LoadingOverlay active={true} spinner text='' /> }
    {this.state.loading_overlay && (
          <DarkBackground disappear={this.state.loading_overlay}>

            <LoadingOverlay
              active={this.state.loading_overlay}
              // spinner={<BounceLoader />}
              spinner={this.state.loading_overlay}
              text={this.state.loadingText}
              style={{ textAlign: "center", alignItem: "center" }}
            >
              {/* <p>Some content or children or something.</p> */}
            </LoadingOverlay>
          </DarkBackground>
        )}
        <div >
          <CardBody>
            <div className="card__title">
              <h5 className="bold-text"></h5>
            </div>
            <form className="form form--inline" onSubmit={handleSubmit}>
              <div
                className="form__form-group col-xl-4"
                style={{ display: "inline-flex" }}
              >
                <span
                  className="form__form-group-label col-xl-5"
                  style={{ display: "none", paddingTop: 6, paddingBottom: 6 }}
                >
                  Select Picksheet No.
                </span>

                <div
                  className="form__form-group-field col-xl-4"
                  style={{ display: "contents" }}
                >
                  <select
                    className="form-control"
                    value={this.state.value}
                    style={{ fontSize: 13 }}
                    onChange={this.handleChange}
                  >
                    <option value="0">Select Picksheet</option>
                    {this.state.schemas &&
                      this.state.schemas.length > 0 &&
                      this.state.schemas.map((schema) => {
                        return (
                          <option value={schema.batch_id}>
                            {" "}
                            {schema.fileName}
                          </option>
                        );
                      })}
                  </select>
                </div>
              </div>

              {/*<div className="form__form-group col-xl-3">
                <div className="form__form-group-field">
                  <ButtonToolbar className="form__button-toolbar">
                    <Button
                      color="primary"
                      className="btn-sm"
                      onClick={this.submitClick}
                    >
                      Submit
                    </Button>
                  </ButtonToolbar>
                </div>
              </div>*/}

              <div className="form__form-group col-xl-2">
                <ButtonToolbar className="form__button-toolbar">
                  <button
                    color="primary"
                    className="btn-sm button_enable "
                    style={{
                      fontWeight: "normal",
                      textTransform: "capitalize",
                      borderRadius: 5,
                      backgroundColor: "#70bbfd",
                      color: "#fff",
                      padding: "5px 25px",
                      fontSize: "14px",
                    }}
                    id="button_enable"
                    onClick={this.submitClick}
                  >
                    {this.state.loading && (
                      <i
                        className="fa fa-refresh fa-spin"
                        style={{
                          marginRight: "5px",
                          textTransform: "capitalize",
                        }}
                      />
                    )}
                    Submit
                  </button>
                </ButtonToolbar>
              </div>
            </form>
            <div
              className="notes"
              style={{ paddingTop: "6px", paddingLeft: "15px" }}
            >
              <p style={{ marginBottom: "13px", fontSize: "15px" }}>
                <b>Note</b> : 1. Picking tasks executed on the mobile app will
                get auto-completed.
              </p>
              <p
                style={{
                  marginBottom: "13px",
                  fontSize: "15px",
                  paddingLeft: "47px",
                }}
              >
                2. In case of short picking, it is mandatory to select the
                appropriate reason.
              </p>
              <p
                style={{
                  marginBottom: "13px",
                  fontSize: "15px",
                  paddingLeft: "47px",
                }}
              >
                3. Enter the Crate ID and the quantities picked. Click '+' sign
                if picking is done in multiple crates.
              </p>
              <p
                style={{
                  marginBottom: "13px",
                  fontSize: "15px",
                  paddingLeft: "47px",
                }}
              >
                4. Press the PENDING button to attempt all unallocated / Short
                pick requests / tasks.
              </p>
              <p
                style={{
                  marginBottom: "13px",
                  fontSize: "15px",
                  paddingLeft: "47px",
                  display: 'none'
                }}
              >
                5. Press SYNC button to flow the pick confirmation data to TP.
              </p>
            </div>
          </CardBody>

          {this.state.showFetchGRNData && (
            <CardBody style={{ marginTop: 20 }}>
              <div>
                <ThemeProvider theme={this.getMuiTheme()}>
                  <button
                    color="primary"
                    disabled = {this.state.emp_role != 'Admin' && this.state.emp_role != 'WH / HUB Manager' && this.state.picking_app == "true"}
                    className={
                      this.state.editBtnFlag
                        ? "btn btn-primary btn-sm pull-left"
                        : "btn btn-primary btn-sm pull-left isDisabled"
                    }
                    style={{ margin: "0px", textTransform: "capitalize" }}
                    onClick={this.beforeConfirm}
                    type="submit"
                  >
                    {this.state.loadingbtn && (
                      <i
                        className="fa fa-refresh fa-spin"
                        style={{ marginRight: "5px" }}
                      />
                    )}
                    Confirm
                  </button>

                  <button
                    color="primary"
                    disabled={!this.state.putawayBtnflag}
                    className={
                      !this.state.putawayBtnflag
                        ? "btn btn-primary btn-sm pull-left isDisabled"
                        : "btn btn-primary btn-sm pull-left"
                    }
                    style={{
                      margin: "0px",
                      marginLeft: "10px",
                      textTransform: "capitalize",
                    }}
                    onClick={this.putawayClick}
                    type="submit"
                  >
                    Putaway
                  </button>

                  <button
                    color="primary"
                    disabled={!this.state.pendingBtnflag}
                    className={
                      !this.state.pendingBtnflag
                        ? "btn btn-primary btn-sm pull-left isDisabled"
                        : "btn btn-primary btn-sm pull-left"
                    }
                    style={{
                      margin: "0px",
                      marginLeft: "10px",
                      textTransform: "capitalize",
                    }}
                    onClick={this.shortPickingModalToggle}
                    type="submit"
                  >
                    Pending
                  </button>

                  <button
                    color="primary"
                    className="btn btn-primary btn-sm pull-left"
                    style={{
                      margin: "0px",
                      marginLeft: "10px",
                      textTransform: "capitalize",
                      display: 'none'
                    }}
                    onClick={this.syncClick}
                  >
                    Sync
                  </button>

                  <button
                    color="primary"
                    className="btn btn-primary btn-sm pull-left"
                    style={{
                      margin: "0px",
                      marginLeft: "10px",
                      textTransform: "capitalize",
                      display: 'none'
                    }}
                    disabled={this.state.cancelDisableBtn}
                    onClick={this.cancelPickingHistory}
                  >
                    Cancel
                  </button>

                  <span
                    className="pull-right"
                    onClick={this.downloadExcel}
                    style={{
                      fontSize: "17px",
                      paddingRight: "0px",
                      cursor: "pointer",
                      color: "#919193",
                      paddingTop: "9px",
                    }}
                  >
                    <FontAwesomeIcon icon={faDownload}></FontAwesomeIcon>
                  </span>
                  <MUIDataTable
                    data={GRNData.rows}
                    columns={GRNData.columns}
                    options={options}
                  />
                </ThemeProvider>
              </div>
            </CardBody>
          )}

          {this.state.showFetchGRNDataTester && (
            <CardBody style={{ marginTop: 20 }}>
              <div>
                <ThemeProvider theme={this.getMuiTheme()}>
                  <button
                    color="primary"
                    disabled={this.state.disabledBtn}
                    className={
                      this.state.editBtnFlag
                        ? "btn btn-primary btn-sm pull-left"
                        : "btn btn-primary btn-sm pull-left isDisabled"
                    }
                    style={{ margin: "0px", textTransform: "capitalize" }}
                    onClick={this.beforeConfirm}
                    type="submit"
                  >
                    {this.state.loadingbtn && (
                      <i
                        className="fa fa-refresh fa-spin"
                        style={{ marginRight: "5px" }}
                      />
                    )}
                    Confirm
                  </button>

                  <button
                    color="primary"
                    disabled={!this.state.putawayBtnflag}
                    className={
                      !this.state.putawayBtnflag
                        ? "btn btn-primary btn-sm pull-left isDisabled"
                        : "btn btn-primary btn-sm pull-left"
                    }
                    style={{
                      margin: "0px",
                      marginLeft: "10px",
                      textTransform: "capitalize",
                    }}
                    onClick={this.putawayClick}
                    type="submit"
                  >
                    Putaway
                  </button>

                  <button
                    color="primary"
                    disabled={!this.state.pendingBtnflag}
                    className={
                      !this.state.pendingBtnflag
                        ? "btn btn-primary btn-sm pull-left isDisabled"
                        : "btn btn-primary btn-sm pull-left"
                    }
                    style={{
                      margin: "0px",
                      marginLeft: "10px",
                      textTransform: "capitalize",
                    }}
                    onClick={this.shortPickingModalToggle}
                    type="submit"
                  >
                    Pending
                  </button>

                  <button
                    color="primary"
                    className="btn btn-primary btn-sm pull-left"
                    style={{
                      margin: "0px",
                      marginLeft: "10px",
                      textTransform: "capitalize",
                    }}
                    onClick={this.syncClick}
                  >
                    Sync
                  </button>
				  <button
                    color="primary"
                    className="btn btn-primary btn-sm pull-left"
                    style={{
                      margin: "0px",
                      marginLeft: "10px",
                      textTransform: "capitalize",
                      display: 'none',
                    }}
                    disabled={this.state.cancelDisableBtn}
                    onClick={this.cancelPickingHistory}
                  >
                    Cancel
                  </button>
                  <span
                    className="pull-right"
                    onClick={this.downloadExcel}
                    style={{
                      fontSize: "17px",
                      paddingRight: "0px",
                      cursor: "pointer",
                      color: "#919193",
                      paddingTop: "9px",
                    }}
                  >
                    <FontAwesomeIcon icon={faDownload}></FontAwesomeIcon>
                  </span>
                  <div id="confirm_table">
                  <MUIDataTable
                    data={GRNDataTester.rows}
                    columns={GRNDataTester.columns}
                    options={options}
                  />
                  </div>
                </ThemeProvider>
              </div>
            </CardBody>
          )}
        </div>

        <Modal
          isOpen={modal}
          toggle={this.toggle}
          style={{ maxWidth: 700, height: 500, padding: 0 }}
        >
          <div className="modal__header" style={{ backgroundColor: "#70bbfd" }}>
            <h4
              className="text-modal  modal__title"
              style={{ color: "#fff", paddingTop: 10 }}
            >
              Split Quantity
            </h4>
          </div>
          <div className="modal__body" style={{ marginTop: 10, padding: 16 }}>
            <div style={{ width: "100%" }}>
              <div style={{ width: "30%", float: "left", textAlign: "left" }}>
                <span style={{ fontSize: 15 }}>
                  <span style={{ fontWeight: "bold" }}> LB SKU ID: </span>{" "}
                  <span> {this.state.lbskuid_val} </span>{" "}
                </span>
              </div>

              <div style={{ width: "22%", float: "left", textAlign: "right" }}>
                <span style={{ fontSize: 15 }}>
                  <span style={{ fontWeight: "bold" }}> ICLD Qty: </span>{" "}
                  <span> {this.state.defaultquantity} </span>{" "}
                </span>
              </div>

              <div style={{ width: "22%", float: "left", textAlign: "right" }}>
                <span style={{ fontSize: 15 }}>
                  <span style={{ fontWeight: "bold" }}> PKD: </span>{" "}
                  <span> {this.state.pkd_val} </span>{" "}
                </span>
              </div>

              <div style={{ width: "25%", float: "left", textAlign: "right" }}>
                <span style={{ fontSize: 15 }}>
                  <span style={{ fontWeight: "bold" }}> MRP: </span>{" "}
                  <span> {this.state.mrp_val} </span>{" "}
                </span>
              </div>
            </div>

            <table className="table table-bordered" id="tab_logic">
              <thead style={{ textAlign: "left" }}>
                <tr>
                  <th>BIN</th>
                  <th>QTY</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style={{ textAlign: "left" }}>
                    <div className="search-container">
                      <div className="react-search-field test-class">
                        <input
                          className="react-search-field-input"
                          placeholder="Search for Bearing No."
                          type="text"
                          style={{ padding: 4, borderRadius: 2 }}
                          defaultValue={this.state.typeaheadText}
                          value={this.state.typeaheadText}
                          onChange={this.showTypeahead}
                        />
                      </div>

                      {this.state.showTypeahead && (
                        <div
                          className="suggestions-container"
                          ref={(el) => (this.typeahead = el)}
                        >
                          {this.state.zwz_search_pannel && (
                            <div
                              className="suggestions"
                              onClick={this.closeContainer}
                            >
                              {this.state.data.length > 0 &&
                                this.state.data.map((item, index) => (
                                  <p
                                    key={index}
                                    onClick={() =>
                                      this.setBinId(item.binAddress)
                                    }
                                    className="typeahead-text"
                                  >
                                    {item.binAddress}{" "}
                                  </p>
                                ))}
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  </td>
                  <td style={{ textAlign: "left" }}>
                    <input
                      type="text"
                      value={this.state.quantity}
                      onChange={this.showTypeaheadChange}
                      style={{ padding: 4, borderRadius: 2 }}
                    />
                    <i
                      onClick={this.handleAddRow}
                      class="fa fa-plus-circle"
                      style={{
                        marginLeft: 15,
                        fontSize: 17,
                        cursor: "pointer",
                      }}
                    ></i>
                    <i
                      onClick={this.handleRemoveRow}
                      class="fa fa-minus-circle"
                      aria-hidden="true"
                      style={{
                        marginLeft: 15,
                        fontSize: 17,
                        cursor: "pointer",
                      }}
                    ></i>
                  </td>
                </tr>

                {this.state.rows.map((row, index) => (
                  <tr>
                    <td style={{ textAlign: "left" }}>
                      <div className="search-container">
                        <div className="react-search-field test-class">
                          <input
                            className="react-search-field-input"
                            placeholder="Search for Bin Address"
                            type="text"
                            style={{ padding: 4, borderRadius: 2 }}
                            value={row.binId}
                            onChange={(e) =>
                              this.onBinChange1(index, e.target.value)
                            }
                          />
                        </div>

                        {this.state.showContainer[index] && (
                          <div
                            className="suggestions-container"
                            ref={(el) => (this.typeahead = el)}
                          >
                            <div
                              className="suggestions"
                              onClick={this.closeContainer}
                            >
                              {this.state.data.length > 0 &&
                                this.state.data.map((item, i) => (
                                  <p
                                    key={i}
                                    onClick={() =>
                                      this.setBinIdLoop(index, item.binAddress)
                                    }
                                    className="typeahead-text"
                                  >
                                    {item.binAddress}{" "}
                                  </p>
                                ))}
                            </div>
                          </div>
                        )}
                      </div>
                    </td>
                    <td style={{ textAlign: "left" }}>
                      <input
                        type="text"
                        onChange={(e) =>
                          this.onQuantityChange1(index, e.target.value)
                        }
                        style={{ padding: 4, borderRadius: 2 }}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            <ButtonToolbar className="modal__footer">
              <button
                className="modal_cancel"
                onClick={this.togglePressCancel}
              >
                Cancel
              </button>
              <Button
                style={{
                  backgroundColor: "#24d6a3",
                  color: "#fff",
                  marginLeft: 12,
                }}
                className="modal_ok"
                onClick={this.processData}
              >
                Submit
              </Button>
            </ButtonToolbar>
          </div>
        </Modal>

        {/*<Modal
          isOpen={modalbeforeConfirm}
          toggle={this.beforeConfirm}
          style={{ maxWidth: 700, height: 500, padding: 0 }}
        >
          <div className="modal__header" style={{ backgroundColor: "#70bbfd" }}>
            <h4
              className="text-modal  modal__title"
              style={{ color: "#fff", paddingTop: 10 }}
            >
              Confirmation
            </h4>
          </div>
          <div className="modal__body" style={{ padding: 14 }}>
            <Table
              responsive
              className="table--bordered"
              style={{ marginBottom: 75 }}
            >
              <thead>
                <tr>
                  <th>User Id</th>
                  <th>User Name</th>
                  <th>Select Date</th>
                  <th>Select Time</th>
                </tr>
              </thead>

              <tbody>
                {Object.keys(uniqueZoneData).length > 0 &&
                  _.map(uniqueZoneData, (item, key) => (
                    <tr key={key}>
                      <td>{item.zoneId}</td>
                      <td>{item.zoneName} </td>
                      <td>
                        <DatePicker
                          dateFormat="MM/dd/yyyy"
                          selected={item.date}
                          minDate={new Date()}
                          onChange={(date) =>
                            this.handleChangeDate(item.zoneName, date)
                          }
                        />

                        {this.state.showDateError[item] && (
                          <span> Please Select Date </span>
                        )}
                      </td>

                      <td>
                        <TimePicker
                          format="HH:mm"
                          onChange={(time) =>
                            this.handleChangeTime(item.zoneName, time)
                          }
                        />{" "}
                        <br />
                        {item.error && (
                          <span style={{ color: "red" }}>{item.error}</span>
                        )}
                      </td>
                    </tr>
                  ))}
              </tbody>
            </Table>

            {this.state.isEmptyCrateArr && (
              <span style={{ color: "red" }}>
                Please fill Crate detail for all lines
              </span>
            )}

            <ButtonToolbar className="modal__footer">
              <Button
                style={{ backgroundColor: "#ddd", color: "#fff" }}
                className="modal_ok"
                onClick={this.CancelBeforeModal}
              >
                Cancel
              </Button>
              <Button
                disabled={this.state.disabledBtnConfirm}
                style={{
                  backgroundColor: "#24d6a3",
                  color: "#fff",
                  marginLeft: 12,
                  textTransform: "capitalize",
                }}
                className="modal_ok"
                onClick={this.ConfirmPutAway}
              >
                {this.state.showConfirmLoader && (
                  <i
                    className="fa fa-refresh fa-spin"
                    style={{ marginRight: "5px" }}
                  />
                )}
                Confirm
              </Button>
            </ButtonToolbar>
          </div>
        </Modal>*/}

        <Modal
          isOpen={modalbeforeConfirm}
          toggle={this.beforeConfirm}
          style={{ maxWidth: 400, height: 500, padding: 0 }}
        >
          <div className="modal__header" style={{ backgroundColor: "#70bbfd" }}>
            <h4
              className="text-modal  modal__title"
              style={{ color: "#fff", paddingTop: 10 }}
            >
              Confirmation
            </h4>
          </div>
          <div className="modal__body" style={{ padding: 14 }}>
           
            <h4> Are you sure you want to confirm? </h4>
           

            <ButtonToolbar className="modal__footer">
              <button
                className="modal_cancel"
                onClick={this.CancelBeforeModal}
              >
                Cancel
              </button>
              <Button
                disabled={this.state.disabledBtnConfirm}
                style={{
                  backgroundColor: "#24d6a3",
                  color: "#fff",
                  marginLeft: 12,
                  textTransform: "capitalize",
                }}
                className="modal_ok"
                onClick={this.ConfirmPutAway}
              >
                {this.state.showConfirmLoader && (
                  <i
                    className="fa fa-refresh fa-spin"
                    style={{ marginRight: "5px" }}
                  />
                )}
                Confirm
              </Button>
            </ButtonToolbar>
          </div>
        </Modal>

        <Modal
          isOpen={EditModal}
          toggle={this.EditToggle}
          style={{ maxWidth: 800, height: 500, padding: 0 }}
        >
          <div className="modal__header" style={{ backgroundColor: "#70bbfd" }}>
            <h4
              className="text-modal  modal__title"
              style={{ color: "#fff", paddingTop: 10 }}
            >
              Edit Entry
            </h4>
          </div>
          <div className="modal__body" style={{ padding: 12 }}>
            <div style={{ width: "100%" }}>
              <div
                style={{
                  width: "30%",
                  float: "left",
                  textAlign: "left",
                  marginLeft: "21px",
                }}
              >
                <span style={{ fontSize: 15 }}>
                  <span style={{ fontWeight: "bold" }}> LB SKU ID : </span>{" "}
                  <span> {this.state.lbskuid_val} </span>
                </span>
              </div>

              <div style={{ width: "20%", float: "left", textAlign: "left" }}>
                <span style={{ fontSize: 15 }}>
                  <span style={{ fontWeight: "bold" }}> BIN ID : </span>{" "}
                  <span> {this.state.binId} </span>{" "}
                </span>
              </div>

              <div style={{ width: "15%", float: "left", textAlign: "left" }}>
                <span style={{ fontSize: 15 }}>
                  <span style={{ fontWeight: "bold" }}> PKD : </span>{" "}
                  <span> {this.state.pkd_val} </span>{" "}
                </span>
              </div>

              <div style={{ width: "20%", float: "left", textAlign: "left" }}>
                <span style={{ fontSize: 15 }}>
                  <span style={{ fontWeight: "bold" }}> MRP : </span>{" "}
                  <span> {this.state.mrp_val} </span>{" "}
                </span>
              </div>
            </div>

            {this.state.table_row[this.state.pickingHistoryId].map(
              (row_index) => {
                crate_index = crate_index + 1;
                if (parseInt(row_index) == 1) {
                  return (
                    <Table
                      responsive
                      className="table"
                      style={{ marginBottom: 0, marginTop: 20, border: "0px" }}
                    >
                      <tbody>
                        <tr>
                          <tr>
                            <td style={{ paddingLeft: 0, paddingRight: 0 }}>
                              Picked Qty (ICLD)
                            </td>
                            <td style={{ paddingLeft: 0, paddingRight: 0 }}>
                              Picked Qty (Loose)
                            </td>
                            {/*<td style={{ paddingLeft: 0, paddingRight: 0 }}>
                              Pick Qty Tester
                            </td>*/}
                            <td style={{ paddingLeft: 0, paddingRight: 0 }}>
                              Crate Id
                            </td>
                            <td style={{ paddingLeft: 0, paddingRight: 0 }}>
                              Crate Qty (ICLD)
                            </td>
                            <td style={{ paddingLeft: 0, paddingRight: 0 }}>
                              Crate Qty (Loose)
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <input
                                type="text"
                                defaultValue={this.state.icldQty1}
                                onChange={this.changeICLDQty}
                                style={{
                                  padding: 4,
                                  borderRadius: 2,
                                  marginLeft: "0px",
                                  width: "80%",
                                  borderColor: "#dddddd",
                                  borderWidth: "1px",
                                  borderStyle: "solid",
                                }}
                                disabled={this.state.isDisabledICLD}
                              />
                              <br />
                              {this.state.showICLDError && (
                                <span style={{ fontSize: 11, color: "red" }}>
                                  {" "}
                                  Pick Icld quantity exceeds actual pick
                                  quantity{" "}
                                </span>
                              )}
                            </td>

                            <td>
                              <input
                                type="text"
                                defaultValue={
                                  this.state.looseQty1 == undefined ||
                                  parseInt(this.state.looseQty1) == 0
                                    ? this.state.testerQty1
                                    : this.state.looseQty1
                                }
                                onChange={
                                  this.state.looseQty1 == undefined ||
                                  parseInt(this.state.looseQty1) == 0
                                    ? this.changeTesterQty
                                    : this.changeLooseQty
                                }
                                style={{
                                  padding: 4,
                                  borderRadius: 2,
                                  width: "80%",
                                  borderColor: "#dddddd",
                                  borderWidth: "1px",
                                  borderStyle: "solid",
                                }}
                                disabled={this.state.isDisabledLOOSE}
                              />
                              <br />
                              {this.state.showLooseError && (
                                <span style={{ fontSize: 11, color: "red" }}>
                                  {" "}
                                  Pick Loose quantity exceeds actual quantity{" "}
                                </span>
                              )}
                            </td>

                            {/*<td>
                              <input
                                type="text"
                                defaultValue={this.state.testerQty1}
                                onChange={this.changeTesterQty}
                                style={{
                                  padding: 4,
                                  borderRadius: 2,
                                  width: "80%",
                                  borderColor: "#dddddd",
                                  borderWidth: "1px",
                                  borderStyle: "solid",
                                }}
                              />
                              <br />
                              {this.state.showTesterError && (
                                <span style={{ fontSize: 11, color: "red" }}>
                                  {" "}
                                  Pick Tester quantity exceeds actual pick
                                  quantity{" "}
                                </span>
                              )}
                            </td>*/}
                            <td style={{ paddingLeft: 0, paddingRight: 0 }}>
                              <input
                                type="text"
                                style={{
                                  padding: 4,
                                  borderRadius: 2,
                                  marginLeft: "0px",
                                  width: "80%",
                                  borderColor: "#dddddd",
                                  borderWidth: "1px",
                                  borderStyle: "solid",
                                }}
                                defaultValue={
                                  this.state.pickHistoryCrateArr[
                                    this.state.pickingHistoryId
                                  ] == undefined
                                    ? ""
                                    : this.state.pickHistoryCrateArr[
                                        this.state.pickingHistoryId
                                      ][crate_index]["crate_id"]
                                }
                                class="crate_input_id"
                              />

                              {this.state.showMandatoryCrateId[row_index] && (
                                <span
                                  style={{
                                    fontSize: 11,
                                    color: "red",
                                    display: "inherit",
                                    padding: "5px 0px",
                                  }}
                                >
                                  {" "}
                                  Crate ID should not be blank
                                </span>
                              )}
                            </td>

                            <td style={{ paddingLeft: 0, paddingRight: 0 }}>
                              <input
                                type="text"
                                style={{
                                  padding: 4,
                                  borderRadius: 2,
                                  marginLeft: "0px",
                                  width: "80%",
                                  borderColor: "#dddddd",
                                  borderWidth: "1px",
                                  borderStyle: "solid",
                                }}
                                disabled={this.state.isDisabledICLD}
                                defaultValue={
                                  this.state.pickHistoryCrateArr[
                                    this.state.pickingHistoryId
                                  ] == undefined
                                    ? ""
                                    : this.state.pickHistoryCrateArr[
                                        this.state.pickingHistoryId
                                      ][crate_index]["icld_qty"]
                                }
                                class="crate_input_id_icld"
                              />

                              {this.state.showMandatoryCrateIcld[row_index] && (
                                <span
                                  style={{
                                    fontSize: 11,
                                    color: "red",
                                    display: "inherit",
                                    padding: "5px 0px",
                                  }}
                                >
                                  {" "}
                                  ICLD Qty should not be blank
                                </span>
                              )}
                            </td>
                            <td style={{ paddingLeft: 0, paddingRight: 0 }}>
                              <input
                                type="text"
                                style={{
                                  padding: 4,
                                  borderRadius: 2,
                                  marginLeft: "0px",
                                  width: "80%",
                                  borderColor: "#dddddd",
                                  borderWidth: "1px",
                                  borderStyle: "solid",
                                }}
                                disabled={this.state.isDisabledLOOSE}
                                defaultValue={
                                  this.state.pickHistoryCrateArr[
                                    this.state.pickingHistoryId
                                  ] == undefined
                                    ? ""
                                    : this.state.pickHistoryCrateArr[
                                        this.state.pickingHistoryId
                                      ][crate_index]["loose_qty"]
                                }
                                class="crate_input_id_loose"
                              />

                              <span
                                onClick={this.addTableRowInTable}
                                style={{ paddingLeft: "10px", display: 'none' }}
                              >
                                <FontAwesomeIcon
                                  icon={faPlus}
                                ></FontAwesomeIcon>
                              </span>

                              {this.state.showMandatoryCrateLoose[
                                row_index
                              ] && (
                                <span
                                  style={{
                                    fontSize: 11,
                                    color: "red",
                                    display: "inherit",
                                    padding: "5px 0px",
                                  }}
                                >
                                  {" "}
                                  Loose Qty should not be blank
                                </span>
                              )}
                            </td>
                          </tr>
                        </tr>
                      </tbody>
                    </Table>
                  );
                } else {
                  return (
                    <Table
                      responsive
                      className="table"
                      style={{ marginBottom: 0, marginTop: 0, border: "0px" }}
                    >
                      <tbody>
                        <tr>
                          <tr>
                            <td>
                              <input
                                type="text"
                                defaultValue={this.state.icldQty1}
                                onChange={this.changeICLDQty}
                                style={{
                                  padding: 4,
                                  borderRadius: 2,
                                  marginLeft: "0px",
                                  width: "80%",
                                  borderColor: "#dddddd",
                                  borderWidth: "1px",
                                  borderStyle: "solid",
                                }}
                                disabled={this.state.isDisabledICLD}
                              />
                              <br />
                              {this.state.showICLDError && (
                                <span style={{ fontSize: 11, color: "red" }}>
                                  {" "}
                                  Pick Icld quantity exceeds actual pick
                                  quantity{" "}
                                </span>
                              )}
                            </td>

                            <td>
                              <input
                                type="text"
                                defaultValue={
                                  this.state.looseQty1 == undefined ||
                                  parseInt(this.state.looseQty1) == 0
                                    ? this.state.testerQty1
                                    : this.state.looseQty1
                                }
                                onChange={
                                  this.state.looseQty1 == undefined ||
                                  parseInt(this.state.looseQty1) == 0
                                    ? this.changeTesterQty
                                    : this.changeLooseQty
                                }
                                style={{
                                  padding: 4,
                                  borderRadius: 2,
                                  width: "80%",
                                  borderColor: "#dddddd",
                                  borderWidth: "1px",
                                  borderStyle: "solid",
                                }}
                                disabled={this.state.isDisabledLOOSE}
                              />
                              <br />
                              {this.state.showLooseError && (
                                <span style={{ fontSize: 11, color: "red" }}>
                                  {" "}
                                  Pick Loose quantity exceeds actual quantity{" "}
                                </span>
                              )}
                            </td>

                            {/*<td>
                              <input
                                type="text"
                                defaultValue={this.state.testerQty1}
                                onChange={this.changeTesterQty}
                                style={{
                                  padding: 4,
                                  borderRadius: 2,
                                  width: "80%",
                                  borderColor: "#dddddd",
                                  borderWidth: "1px",
                                  borderStyle: "solid",
                                }}
                              />
                              <br />
                              {this.state.showTesterError && (
                                <span style={{ fontSize: 11, color: "red" }}>
                                  {" "}
                                  Pick Tester quantity exceeds actual pick
                                  quantity{" "}
                                </span>
                              )}
                            </td>*/}
                            <td style={{ paddingLeft: 0, paddingRight: 0 }}>
                              <input
                                type="text"
                                style={{
                                  padding: 4,
                                  borderRadius: 2,
                                  marginLeft: "0px",
                                  width: "80%",
                                  borderColor: "#dddddd",
                                  borderWidth: "1px",
                                  borderStyle: "solid",
                                }}
                                defaultValue={
                                  this.state.pickHistoryCrateArr[
                                    this.state.pickingHistoryId
                                  ] == undefined
                                    ? ""
                                    : this.state.pickHistoryCrateArr[
                                        this.state.pickingHistoryId
                                      ][crate_index] == undefined
                                    ? ""
                                    : this.state.pickHistoryCrateArr[
                                        this.state.pickingHistoryId
                                      ][crate_index]["crate_id"]
                                }
                                class="crate_input_id"
                              />

                              {this.state.showMandatoryCrateId[row_index] && (
                                <span
                                  style={{
                                    fontSize: 11,
                                    color: "red",
                                    display: "inherit",
                                    padding: "5px 0px",
                                  }}
                                >
                                  {" "}
                                  Crate ID should not be blank
                                </span>
                              )}
                            </td>

                            <td style={{ paddingLeft: 0, paddingRight: 0 }}>
                              <input
                                type="text"
                                style={{
                                  padding: 4,
                                  borderRadius: 2,
                                  marginLeft: "0px",
                                  width: "80%",
                                  borderColor: "#dddddd",
                                  borderWidth: "1px",
                                  borderStyle: "solid",
                                }}
                                disabled={this.state.isDisabledICLD}
                                defaultValue={
                                  this.state.pickHistoryCrateArr[
                                    this.state.pickingHistoryId
                                  ] == undefined
                                    ? ""
                                    : this.state.pickHistoryCrateArr[
                                        this.state.pickingHistoryId
                                      ][crate_index] == undefined
                                    ? ""
                                    : this.state.pickHistoryCrateArr[
                                        this.state.pickingHistoryId
                                      ][crate_index]["icld_qty"]
                                }
                                class="crate_input_id_icld"
                              />

                              {this.state.showMandatoryCrateIcld[row_index] && (
                                <span
                                  style={{
                                    fontSize: 11,
                                    color: "red",
                                    display: "inherit",
                                    padding: "5px 0px",
                                  }}
                                >
                                  {" "}
                                  ICLD Qty should not be blank
                                </span>
                              )}
                            </td>
                            <td style={{ paddingLeft: 0, paddingRight: 0 }}>
                              <input
                                type="text"
                                style={{
                                  padding: 4,
                                  borderRadius: 2,
                                  marginLeft: "0px",
                                  width: "80%",
                                  borderColor: "#dddddd",
                                  borderWidth: "1px",
                                  borderStyle: "solid",
                                }}
                                disabled={this.state.isDisabledLOOSE}
                                defaultValue={
                                  this.state.pickHistoryCrateArr[
                                    this.state.pickingHistoryId
                                  ] == undefined
                                    ? ""
                                    : this.state.pickHistoryCrateArr[
                                        this.state.pickingHistoryId
                                      ][crate_index] == undefined
                                    ? ""
                                    : this.state.pickHistoryCrateArr[
                                        this.state.pickingHistoryId
                                      ][crate_index]["loose_qty"]
                                }
                                class="crate_input_id_loose"
                              />

                              <span
                                onClick={this.deleteClickedRow}
                                style={{ paddingLeft: "10px" }}
                              >
                                <FontAwesomeIcon
                                  icon={faMinus}
                                ></FontAwesomeIcon>
                              </span>

                              {this.state.showMandatoryCrateLoose[
                                row_index
                              ] && (
                                <span
                                  style={{
                                    fontSize: 11,
                                    color: "red",
                                    display: "inherit",
                                    padding: "5px 0px",
                                  }}
                                >
                                  {" "}
                                  Loose Qty should not be blank
                                </span>
                              )}
                            </td>
                          </tr>
                        </tr>
                      </tbody>
                    </Table>
                  );
                }
              }
            )}

            {this.state.showPickCrateLoose && (
              <span style={{ fontSize: 11, color: "red" }}>
                {" "}
                Qty doesn't match
              </span>
            )}

            {/*this.state.showPickCrateLoose && (
              <span style={{ fontSize: 11, color: "red" }}>
                {" "}
                Qty doesn't match
              </span>
            )*/}

            <Table
              responsive
              className="table"
              style={{ marginBottom: 0, marginTop: 15, border: "0px" }}
            >
              <tr>
                <td
                  style={{
                    border: "0px",
                    textAlign: "left",
                    paddingLeft: "22px",
                    width: "38%",
                  }}
                >
                  Select Reason Code for short picking
                </td>
                <td style={{ border: "0px", textAlign: "left" }}>
                  <select
                    onChange={this.handlereasoncode}
                    style={{ padding: 4, borderRadius: 2, width: "40%" }}
                    disabled={!this.state.showTESTERReasonCode}
                    defaultValue={
                      this.state.reason_code[this.state.pickingHistoryId] !=
                      undefined
                        ? this.state.reason_code[this.state.pickingHistoryId]
                        : ""
                    }
                  >
                  <option value=''>Select Reason</option>
				  {this.state.reasonDropdown.map(reason => <option value={reason["reason_code"]}>{reason["description"]}</option> )}
                  </select>
                  {this.state.validateReasonCode && (
                    <span
                      style={{
                        fontSize: 11,
                        color: "red",
                        paddingLeft: "10px",
                      }}
                    >
                      Select reason code
                    </span>
                  )}
                </td>
              </tr>
            </Table>

            {reasonCodeMsg !== "" && (
              <p style={{ textAlign: "left", paddingLeft: "22px" }}>
                Note : {reasonCodeMsg}
              </p>
            )}
            <ButtonToolbar className="modal__footer">
              <button
                className="modal_cancel"
                onClick={this.togglePressCancel}
              >
                Cancel
              </button>
              <Button
                style={{
                  backgroundColor: "#24d6a3",
                  color: "#fff",
                  marginLeft: 12,
                  backgroundColor: "#3ea3fc",
                }}
                className="modal_ok"
                disabled={this.state.updateDisabled}
                onClick={this.processUpdateData}
              >
                {this.state.showUpdateLoader && (
                  <i
                    className="fa fa-refresh fa-spin"
                    style={{ marginRight: "5px" }}
                  />
                )}
                Update
              </Button>
            </ButtonToolbar>
          </div>
        </Modal>

        <Modal isOpen={Errormodal} toggle={this.Errortoggle}>
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.Errortoggle}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr lnr-cross-circle modal__title-icon"
              style={{ color: "red" }}
            />
            <h4>{this.state.ErrorMessage} </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button
              style={{ backgroundColor: "#24d6a3", color: "#fff" }}
              className="modal_ok"
              onClick={this.Errortoggle}
            >
              Ok
            </Button>
          </ButtonToolbar>
        </Modal>

        <Modal isOpen={Successmodal} toggle={this.Successtoggle}>
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.Successtoggle}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr lnr-checkmark-circle modal__title-icon"
              style={{ color: "green" }}
            />
            <h4>Successfully Updated </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button
              style={{ backgroundColor: "#24d6a3", color: "#fff" }}
              className="modal_ok"
              onClick={this.CancelSuccessToggle}
            >
              Ok
            </Button>
          </ButtonToolbar>
        </Modal>

        <Modal isOpen={Confirmmodal} toggle={this.Confirmtoggle}>
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.Confirmtoggle}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr lnr-checkmark-circle modal__title-icon"
              style={{ color: "green" }}
            />
            <h4>Successfully Updated </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button
              style={{
                backgroundColor: "#24d6a3",
                color: "#fff",
                textTransform: "capitalize",
              }}
              className="modal_ok"
              onClick={this.CancelConfirmToggle}
            >
              Ok
            </Button>
          </ButtonToolbar>
        </Modal>

        <Modal isOpen={ErrorMessagemodal} toggle={this.ErrorMessagetoggle}>
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.Confirmtoggle}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr lnr-cross-circle modal__title-icon"
              style={{ color: "red" }}
            />
            <h4>{this.state.errorMessage} </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <button
              className="modal_cancel"
              onClick={this.CancelErrorMessageToggle}
            >
              Cancel
            </button>
          </ButtonToolbar>
        </Modal>
        <Modal
          isOpen={this.state.shortPickingModal}
          toggle={this.shortPickingModalToggle}
          style={{ maxWidth: 800, height: "auto", padding: 0 }}
        >
          <div className="modal__header" style={{ backgroundColor: "#70bbfd" }}>
            <h4
              className="text-modal  modal__title"
              style={{ color: "#fff", paddingTop: 10 }}
            >
              Short Picking
            </h4>
          </div>
          <div className="modal__body" style={{ padding: 12 }}>
            <MDBDataTable
              striped
              bordered
              hover
              scrollY
              scrollX
              paging={false}
              searching={false}
              data={productData}
              // scrollX={true}
            />
            {/* <Table
      scrollY
      min-height={100}
              className="table--bordered"
            >
              <thead>
        <th><input type="checkbox" onChange={this.handleallCheckBoxClick} selected={false}/></th>
        <th>LB SKU ID</th>
        <th>LB SKU Product Name</th>
        <th>PKD</th>
        <th>CBU Code</th>
        <th>Basepack Code</th>
        <th>Pending for Picking</th>
        <th>Stock Available</th>
        </thead>
        <tbody>
        {this.state.shortPickingRows.map(shortPickingObj => 
          <tr>
        <td><input type="checkbox" name={shortPickingObj.pickingHistoryId} className="checkbox_div" selected={this.state.selected[shortPickingObj.pickingHistoryId]} onChange={this.handleCheckBoxClick} /></td>
        <td>{shortPickingObj.lbSkuId}</td>
        <td>{shortPickingObj.productName}</td>
        <td>{shortPickingObj.pkd}</td>
        <td>{shortPickingObj.cbuCode}</td>
        <td>{shortPickingObj.basePackCode}</td>
        <td>{shortPickingObj.lbSkuId}</td>
        <td>{shortPickingObj.lbSkuId}</td>
        </tr>
        )}
              </tbody>
        </Table>*/}
            {this.state.stock_available_not_zero && (
              <p
                style={{
                  color: "red",
                  padding: "10px",
                  fontSize: "15px",
                  margin: "15px",
                }}
              >
                Stock Availability is 0
              </p>
            )}
            <ButtonToolbar className="modal__footer">
              <button

                className="modal_cancel"
                onClick={this.shortPickingModalToggle}
              >
                Cancel
              </button>
              <Button
                style={{
                  backgroundColor: "#24d6a3",
                  color: "#fff",
                  marginLeft: 12,
                  backgroundColor: "#3ea3fc",
                }}
                className={
                  this.state.sp_proceed_btn_disabled
                    ? "modal_ok isDisabled"
                    : "modal_ok"
                }
                disabled={
                  this.state.stock_available_not_zero
                    ? this.state.stock_available_not_zero
                    : this.state.sp_proceed_btn_disabled
                }
                onClick={this.pickingpendingClick}
              >
                {this.state.showUpdateLoader && (
                  <i
                    className="fa fa-refresh fa-spin"
                    style={{ marginRight: "5px" }}
                  />
                )}
                Re-Assign
              </Button>
              <Button
                style={{
                  backgroundColor: "#24d6a3",
                  color: "#fff",
                  marginLeft: 12,
                  backgroundColor: "#3ea3fc",
                }}
                className={
                  this.state.sp_proceed_btn_disabled
                    ? "modal_ok isDisabled"
                    : "modal_ok"
                }
                disabled={this.state.sp_proceed_btn_disabled}
                onClick={this.completeShortPicking}
              >
                Close Picksheet
              </Button>
            </ButtonToolbar>
          </div>
        </Modal>

        <Modal
          isOpen={this.state.pickingHisCancel}
          toggle={this.cancelPickingHistory}
        >
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.cancelPickingHistory}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr lnr-checkmark-circle modal__title-icon"
              style={{ color: "green" }}
            />
            <h4>Are you sure you want to cancel it? </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <button
              className="modal_cancel"
              onClick={this.cancelBtnHandler}
            >
              Cancel
            </button>

            <Button
              style={{
                backgroundColor: "#24d6a3",
                color: "#fff",
                marginLeft: "20px",
              }}
              className="modal_ok"
              onClick={this.okHandler}
            >
              Ok
            </Button>
          </ButtonToolbar>
        </Modal>
      </Col>
    );
  }
}

export default reduxForm({
  form: "Upload Master", // a unique identifier for this form
})(withTranslation("common")(HorizontalForm));